export const files = [
    {
        "character": "Arthur - Le Roi Burgonde",
        "episode": "Livre II, 03 - Le Dialogue de Paix",
        "file": "interprete.mp3",
        "title": "Interprète"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 26 - Corpore sano",
        "file": "je_ne_mange_pas_de_graines.mp3",
        "title": "JE NE MANGE PAS DE GRAINES"
    },
    {
        "character": "Merlin",
        "episode": "Livre I, 15 - Les Défis de Merlin",
        "file": "putain_il_est_fort_ce_con.mp3",
        "title": "Putain il est fort ce con"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 12 - Les Classes de Bohort",
        "file": "mais_je_vous_emmerde_mon_ptit_pote.mp3",
        "title": "Mais je vous emmerde mon p'tit pote"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 62 - Le Jeu de la Guerre",
        "file": "pas_la_moindre_idee.mp3",
        "title": "Attendez, on est bien d'accord que j'ai pas la moindre idée de ce que je fous avec mes oeufs... J'ai jamais joué à ça je sais même pas ce qu'il faut faire."
    },
    {
        "character": "Breccan",
        "episode": "Livre I, 03 - La Table de Breccan",
        "file": "apres_pour_le_detail_je_sais_pas.mp3",
        "title": "Ah bah ça après, moi, pour le détail, je sais pas"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 05 - Le Fléau de Dieu",
        "file": "cest_pas_jo_le_rigolo.mp3",
        "title": "Ah c'est sûr qu'c'est pas Jo l'Rigolo, hein"
    },
    {
        "character": "Attila",
        "episode": "Livre I, 05 - Le Fléau de Dieu",
        "file": "pourquoi_pas1.mp3",
        "title": "POURQUOI PAS ?"
    },
    {
        "character": "Attila",
        "episode": "Livre I, 05 - Le Fléau de Dieu",
        "file": "pourquoi_pas2.mp3",
        "title": "Pourquoi pas !?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 08 - Codes et Stratégies",
        "file": "sortez-vous_les_doigts_du_cul.mp3",
        "title": "SORTEZ-VOUS LES DOIGTS DU CUL"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "ptite_pucelle.mp3",
        "title": "P'tite pucelle"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "en_garde_espece_de_vieille_pute_degarnie.mp3",
        "title": "En garde, espèce de vieille pute dégarnie"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 10 - Le Négociateur",
        "file": "ca_va_un_peu_trop_vite_pour_moi.mp3",
        "title": "Ouh, ça va un peu trop vite pour moi"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 10 - Arthur et la Question",
        "file": "ca_vous_ennuie_si_je_vomis.mp3",
        "title": "Ça vous ennuie si j'vomis ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 12 - Le Sixième Sens",
        "file": "vous_allez_fermer_vos_mouilles_oui.mp3",
        "title": "VOUS ALLEZ FERMER VOS MOUILLES OUI ?"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 14 - Monogame",
        "file": "madresse_pas_la_parole.mp3",
        "title": "M'ADRESSE PAS LA PAROLE HÉRÉTIQUE, DÉMON"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 79 - L'Expurgation de Merlin",
        "file": "bucher1.mp3",
        "title": "HÉRÉTIQUE ! AU BUCHER !"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 79 - L'Expurgation de Merlin",
        "file": "bucher2.mp3",
        "title": "HÉRÉTIQUE ! AU BUCHER ! 2"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 79 - L'Expurgation de Merlin",
        "file": "bucher3.mp3",
        "title": "HÉRÉTIQUE ! AU BUCHER ! 3"
    },
    {
        "character": "Venec",
        "episode": "Livre I, 16 - Le Banquet des Chefs",
        "file": "federer_mes_couilles.mp3",
        "title": "S'ils arrivent et qu'y a pas d'femmes, vous allez fédérer mes couilles"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 17 - Le Signe",
        "file": "zut_la.mp3",
        "title": "Zut ! Là."
    },
    {
        "character": "Le tavernier",
        "episode": "Livre I, 18 - En Forme de Graal",
        "file": "il_est_pas_beau_mon_graal.mp3",
        "title": "Eh, il est pas beau mon Graal ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 19 - Le Repos du Guerrier",
        "file": "commencez_pas_a_me_faire_chier.mp3",
        "title": "Ah vous ne commencez pas à me faire chier, c'est pas l'soir"
    },
    {
        "character": "L'Interprète",
        "episode": "Livre I, 24 - L'Interprète",
        "file": "il_pue_il_pete.mp3",
        "title": "Il pue, il pète, il lâche des ruines"
    },
    {
        "character": "L'Interprète",
        "episode": "Livre I, 24 - L'Interprète",
        "file": "burgonde_ou_anglais.mp3",
        "title": "Il restait que burgonde ou anglais, anglais"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 25 - Le Sacrifice",
        "file": "allez_boire_un_coup.mp3",
        "title": "Non mais allez boire un coup, je vous assure, ça ira mieux"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 26 - À la volette",
        "file": "cest_vrai_quelle_reste.mp3",
        "title": "C'est vrai qu'elle reste celle-là"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 26 - À la volette",
        "file": "a_la_volette1.mp3",
        "title": "À la volette"
    },
    {
        "character": "Dagonet",
        "episode": "Livre I, 27 - De retour de Judée",
        "file": "un_bon_quart_dheure.mp3",
        "title": "À mon avis, un bon quart d'heure et on a fait le tour"
    },
    {
        "character": "Lancelot",
        "episode": "Livre I, 27 - De retour de Judée",
        "file": "oh_la_vache.mp3",
        "title": "Oh la vache !"
    },
    {
        "character": "Le tavernier",
        "episode": "Livre I, 28 - La Botte secrète",
        "file": "cest_pas_une_sinecure.mp3",
        "title": "J'peux vous dire qu'tavernier, c'est pas une sinécure"
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 28 - La Botte secrète",
        "file": "cest_pas_faux1.mp3",
        "title": "C'est pas faux"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 28 - La Botte secrète",
        "file": "cest_pas_faux2.mp3",
        "title": "Ouais c'est pas faux"
    },
    {
        "character": "Angharad",
        "episode": "Livre I, 28 - La Botte secrète",
        "file": "insipide.mp3",
        "title": "J'ai l'impression d'être... insipide, mais alors"
    },
    {
        "character": "Demetra",
        "episode": "Livre I, 30 - Le Trois de cœur",
        "file": "vous_deconnez.mp3",
        "title": "Vous déconnez !?"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 30 - Le Trois de cœur",
        "file": "jpeux_pas_vous_dire.mp3",
        "title": "Ça moi j'peux pas vous dire"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 30 - Le Trois de cœur",
        "file": "ecartez-vous.mp3",
        "title": "OK, écartez-vous, j'vais gerber"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 31 - Basidiomycètes",
        "file": "sourire_comme_des_glands.mp3",
        "title": "Qu'est-ce que vous avez à sourire comme des glands ?"
    },
    {
        "character": "Merlin",
        "episode": "Livre I, 32 - L'Imposteur",
        "file": "laissez_le_a_lair.mp3",
        "title": "Nan mais faut pas toucher ça laissez-le à l'air ça va passer"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 32 - L'Imposteur",
        "file": "soupcon_gros_nul.mp3",
        "title": "J'vous soupçonne d'être un gros nul"
    },
    {
        "character": "Lancelot",
        "episode": "Livre I, 32 - L'Imposteur",
        "file": "vraiment_impressionnant.mp3",
        "title": "Nan mais quand on est sur place c'est vraiment impressionnant"
    },
    {
        "character": "L'évêque Boniface",
        "episode": "Livre I, 33 - Compagnons de chambrée",
        "file": "plait_il.mp3",
        "title": "Plaît-il ?"
    },
    {
        "character": "L'évêque Boniface",
        "episode": "Livre I, 33 - Compagnons de chambrée",
        "file": "a_moi_a_lassassin.mp3",
        "title": "À moi ! À l'assassin !"
    },
    {
        "character": "La Dame du Lac",
        "episode": "Livre I, 34 - La Grotte de Padraig",
        "file": "un_genre_cake.mp3",
        "title": "C'est... un genre de cake"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 34 - La Grotte de Padraig",
        "file": "vous_rigolez_jespere.mp3",
        "title": "Vous rigolez, j'espère !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 35 - Ambidextrie",
        "file": "ca_change_tout.mp3",
        "title": "Selon comme on est tourné, ça change tout"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 35 - Ambidextrie",
        "file": "voila_cest_pro.mp3",
        "title": "Voilà, là c'est pro !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 35 - Ambidextrie",
        "file": "crame_ta_famille.mp3",
        "title": "Toi, un jour, je te crame ta famille, toi"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "faut_ce_qui_faut.mp3",
        "title": "Ah bah faut c'qui faut, hein !"
    },
    {
        "character": "Venec",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "le_pognon_ca_va_ca_vient.mp3",
        "title": "Le pognon ça va, ça vient, il faut jamais paniquer"
    },
    {
        "character": "Venec",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "si_vous_etes_vendeur.mp3",
        "title": "Si vous êtes vendeur, j'vous fais une proposition aux oignons"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "vous_la_crachez_votre_pastille.mp3",
        "title": "Bah vous la crachez votre pastille ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "cest_bien_fait.mp3",
        "title": "C'est bien fait, hein ?"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "cest_honteux.mp3",
        "title": "C'EST HONTEUX"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 36 - Raison d'argent",
        "file": "pas_de_quoi_en_chier_une_galette.mp3",
        "title": "C'est bon, y a pas de quoi en chier une galette"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 37 - La Romance de Lancelot",
        "file": "cest_debile_cette_histoire.mp3",
        "title": "C'est débile cette histoire"
    },
    {
        "character": "Merlin",
        "episode": "Livre I, 38 - Merlin et les Loups",
        "file": "oh_cest_la_vacherie_ca.mp3",
        "title": "Oh c'est la vacherie ça !"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "je_refuse_daller_me_battre.mp3",
        "title": "Je refuse d'aller me battre pour soutenir une politique d'expansion territoriale dont je ne reconnais pas la légitimité."
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "bonjour_la_pedagogie.mp3",
        "title": "Super, bonjour la pédagogie"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 70 - Les Vœux",
        "file": "mais_vous_savez_ce_que_ca_veux_dire_au_moins.mp3",
        "title": "Mais vous savez ce que ça veux dire, au moins ?"
    },
    {
        "character": "Arthur - Galessin",
        "episode": "Livre II, 70 - Les Vœux",
        "file": "voeux_de_pauvrete_jarrivais_pas_a_concilier.mp3",
        "title": "Moi à une époque, je voulais faire vœux de pauvreté — Et alors ? — Ben avec le blé que je rentrais, j'arrivais pas à concilier les deux"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 81 - L'Enragé",
        "file": "il_est_coince_ce_con_la.mp3",
        "title": "Oh hé, merde hé ! C'est pas vrai, il est coincé ce con-là !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 81 - L'Enragé",
        "file": "je_vais_pas_faire_des_aller_retours_3_fois_par_jours.mp3",
        "title": "Après vous vous démerdez, hein, je vais pas faire des aller-retours 3 fois par jour, je vous préviens !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 81 - L'Enragé",
        "file": "jai_arrete_les_pronostics.mp3",
        "title": "Avec celui-là vous savez, ça fait un moment que j'ai arrêté les pronostics !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 41 - Arthur et les Ténèbres",
        "file": "nempeche_que_cest_moi_qui_avait_propose.mp3",
        "title": "N'empêche que c'est moi qui avait proposé"
    },
    {
        "character": "Calogrenant",
        "episode": "Livre I, 41 - Arthur et les Ténèbres",
        "file": "ouais_ca_aussi.mp3",
        "title": "Ouais, Ouais… Ouais ça aussi"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 59 - La Jupe de Calogrenant",
        "file": "cest_le_genre_dendroit_ou_il_faut_parler_fort.mp3",
        "title": "Je vois ! Je suppose que c'est le genre d'endroit où il faut parler fort et se taper dans le dos !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "je_vois_pas_le_rapport_avec_bretagne.mp3",
        "title": "J'vois pas le rapport avec la Bretagne"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 41 - Arthur et les Ténèbres",
        "file": "venir_foutre_votre_merde.mp3",
        "title": "Faut toujours que vous veniez foutre votre merde"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 42 - Le Zoomorphe",
        "file": "lair_idiote.mp3",
        "title": "Je vais avoir l'air d'une idiote"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 43 - La Coccinelle de Madenn",
        "file": "toujours_se_plaindre_pequenauds.mp3",
        "title": "Sont toujours en train de se plaindre ces péquenauds"
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 44 - Patience dans la plaine",
        "file": "bien_manger_cest_important.mp3",
        "title": "Bien manger c'est important !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 45 - Le Oud",
        "file": "quand_on_se_fache.mp3",
        "title": "Quand on se fâche, il y a toujours un résultat"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "cest_plus_filiforme.mp3",
        "title": "C'est plus filiforme"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "le_graal_par_ci_le_graal_par_la.mp3",
        "title": "Le Graal par ci, le Graal par là"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "moi_je_serais_vous_je_vous_ecouterais.mp3",
        "title": "Moi j'serais vous, j'vous écouterais"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "on_en_a_gros.mp3",
        "title": "ON EN A GROS !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "vous_nous_utilisez_bon_gre_mal_gre_pour_arriver_sur_la_fin.mp3",
        "title": "Vous nous utilisez bon gré, mal gré, pour arriver sur la fin"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "ma_femme_a_pas_de_moustache.mp3",
        "title": "Mais moi, ma femme n'a pas de moustache !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre III, 26 - L'assemblée des rois I",
        "file": "cest_moi_ou_il_y_a_une_ambiance_de_merde.mp3",
        "title": "Euh… c'est moi ou y a une ambiance de merde ?"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "en_garde_ma_mignone.mp3",
        "title": "En garde ma mignonne !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 26 - Corpore sano",
        "file": "le_gras_cest_la_vie.mp3",
        "title": "Le gras, c'est la vie"
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 68 - Le Pain",
        "file": "cest_de_la_merde.mp3",
        "title": "C'est de la merde 1"
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 68 - Le Pain",
        "file": "mais_ya_rien_a_developper_cest_de_la_merde_cest_tout.mp3",
        "title": "Mais y a rien à développer c'est de la merde c'est tout "
    },
    {
        "character": "Le tavernier",
        "episode": "Livre III, 67 - La Baraka",
        "file": "moi_jai_toujours_dit.mp3",
        "title": "Moi j'ai toujours dit"
    },
    {
        "character": "Le tavernier",
        "episode": "Livre III, 67 - La Baraka",
        "file": "moi_jai_toujours_dit2.mp3",
        "title": "Moi j'ai toujours dit 2"
    },
    {
        "character": "Roparzh",
        "episode": "Livre III, 36 - Feue la Poule de Guethenoc",
        "file": "mais_tout_a_fait.mp3",
        "title": "Mais tout à fait"
    },
    {
        "character": "Karadoc",
        "episode": "Livre III, 72 - La restriction II",
        "file": "rien_a_carer.mp3",
        "title": "J'EN AI RIEN À CARER"
    },
    {
        "character": "Séli",
        "episode": "Livre III, 72 - La restriction II",
        "file": "la_bouffe_est_interdite.mp3",
        "title": "La bouffe est interdite en dehors des heures des repas !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 92 - La restriction",
        "file": "je_vois_trouble.mp3",
        "title": "Je vois trouble, c'est le manque de gras, je m'déssèche"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu du caillou",
        "file": "elle_est_ou_la_poulette.mp3",
        "title": "Elle est où la poulette ?"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre III, 26 - L'assemblée des rois - 2ème partie",
        "file": "vous_etes_completement_con.mp3",
        "title": "MAIS VOUS ÊTES COMPLÈTEMENT CONS !"
    },
    {
        "character": "Yvain",
        "episode": "Livre III, 88 - L'étudiant",
        "file": "est_ce_que_peut_servir_elan_pigeon.mp3",
        "title": "Est-ce qu'on peut s'en servir pour donner de l'élan à un pigeon ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 93 - Unagi",
        "file": "ca_vous_fait_pas_mal_a_la_tete_de_glandouiller.mp3",
        "title": "Ça vous fait pas mal à la tête de glandouiller 24h sur 24 ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 42 - La fête du printemps",
        "file": "ah_le_printemps_on_crame_des_mecs.mp3",
        "title": "Ah, le printemps. La nature se réveille, les oiseaux reviennent, on crame des mecs..."
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 95 - L'étudiant",
        "file": "a_roulettes.mp3",
        "title": "A ROULETTES !!!"
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 95 - L'étudiant",
        "file": "le_prochain_qui_l_ouvre_galeres_trois_ans.mp3",
        "title": "Le prochain qui l'ouvre, je l'envoie aux galères pendant trois ans, sans déconner j'le fais."
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 95 - L'étudiant",
        "file": "wooouuuhouhouhou_c_est_mortel.mp3",
        "title": "Wooouuuhouhouhou !!! C'est mortel !"
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 95 - L'étudiant",
        "file": "humilite_infiltration.mp3",
        "title": "De l'humilité ? L'humilité c'est pas quand il y a des infiltrations ?"
    },
    {
        "character": "Elias de Kelliwic'h",
        "episode": "Livre IV, 12 - Le Privilégié",
        "file": "mais_allez_chier_dans_une_fiolle.mp3",
        "title": "Mais allez chier dans une fiole, on verra après"
    },
    {
        "character": "Caius",
        "episode": "Livre IV, 22 - Seigneur Caius",
        "file": "he_les_connards_vous_pouvez_faire_griller_un_porcelet.mp3",
        "title": "Hé les connards ! Vous pouvez faire griller un porcelet s'il vous plaît ?"
    },
    {
        "character": "Roparzh",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "ca_va_encore_faire_des_discussions_a_rallonge.mp3",
        "title": "Ça va encore faire des discussions à rallonge"
    },
    {
        "character": "Roparzh",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "honnetement_je_connais_pas_le_mot_la.mp3",
        "title": "Honnêtement, j'connais pas le mot, là, j'saurais pas vous dire"
    },
    {
        "character": "Roparzh",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "mais_faut_pas_deconner_ils_y_sont_pour_rien.mp3",
        "title": "Mais faut pas déconner, ils y sont pour rien"
    },
    {
        "character": "Roparzh",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "mais_qu_est_ce_que_j_en_ai_a_foutre.mp3",
        "title": "Mais qu'est-ce que j'en ai à foutre de vos horaires, j'arrive quand j'arrive et puis c'est tout"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "dites_tirez_vous.mp3",
        "title": "Dites, euh... tirez-vous"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "mais_je_vous_ai_dis_que_c_etait_important.mp3",
        "title": "Mais j'vous ai dit que c'était important"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "pourquoi_qu_on_gueule.mp3",
        "title": "Pourquoi, hein, qu'on gueule ?"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre IV, 31 - La Révolte III",
        "file": "quand_on_gueule_sans_savoir_pourquoi.mp3",
        "title": "Quand on gueule sans savoir pourquoi, ça facilite pas les négociations derrière, hein, bon"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 50 - Les Nouveaux Frères",
        "file": "deux_trous_du_cul_soient_plus_efficaces_qu_un_seul.mp3",
        "title": "J'pense pas que deux trous du cul soient plus efficaces qu'un seul"
    },
    {
        "character": "Elias de Kelliwic'h",
        "episode": "Livre V, 13 - Les Dauphins",
        "file": "dans_la_vie.mp3",
        "title": "Dans la vie, faut bosser pour personne, et y faut faire bosser personne ! C'est le secret de la liberté."
    },
    {
        "character": "Elias de Kelliwic'h",
        "episode": "Livre V, 05 - La Sorcière",
        "file": "des_vetements.mp3",
        "title": "Des vêtements ?!"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "arretez_de_parler_aux_gens.mp3",
        "title": "Non, moi j'crois qu'il faut qu'vous arrêtiez d'essayer de dire des trucs. Ça vous fatigue, déjà, et pour les autres, vous vous rendez pas compte de c'que c'est. Moi quand vous faites ça, ça me fout une angoisse... j'pourrais vous tuer, j'crois. De chagrin, hein ! J'vous jure c'est pas bien. Il faut plus que vous parliez avec des gens."
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 03 - Le Dialogue de Paix",
        "file": "cuillere.mp3",
        "title": "Cuillère"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 03 - Le Dialogue de Paix",
        "file": "arthour.mp3",
        "title": "Arthour"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre IV, 62 - Le Jeu de la Guerre",
        "file": "arthour_cest_la_guerre.mp3",
        "title": "Arthour c'est la guerre !"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 62 - Le Jeu de la Guerre",
        "file": "bon_on_va_commencer_les_negociations.mp3",
        "title": "Bon ! On va commencer les négociations."
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 62 - Le Jeu de la Guerre",
        "file": "comprend_jamais_un_broc_de_ce_quon_dit.mp3",
        "title": "Je sais c'est trompeur parce qu'il arrive sans interprète et tout, mais il comprend jamais un broc de ce qu'on dit."
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 21 - La cassette",
        "file": "politique_de_l_autruche.mp3",
        "title": "On dit la politique de l'autruche, avant je comprenais pas. Mais maintenant que j'en ai vu une d'autruche, c'est bon ! Une politique qui court vite, une politique qui fait des gros œufs, c'est tout !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 26 - Un Roi à La Taverne",
        "file": "jvoudrais_pas_faire_ma_raclette.mp3",
        "title": "J'voudrais pas faire ma raclette, mais la soirée s'annonce pas super"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 31 - L'Ivresse",
        "file": "pays_de_galles_independant.mp3",
        "title": "PAYS DE GALLES INDÉPENDANT"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "mecreant.mp3",
        "title": "MÉCRÉANT"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "mecreant_2.mp3",
        "title": "MÉCRÉANT 2"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "mettre_du_beurre_au_fond_du_plat.mp3",
        "title": "On met du beurre dans l'fond du plat pour pas qu'le gratin colle"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "pour_savoir_si_il_va_y_avoir_du_vent.mp3",
        "title": "Pour savoir si il va y avoir du vent il faut mettre son doigt dans le cul du coq"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "j_ai_le_droit_d_etre_4_jours_pas_chez_moi.mp3",
        "title": "J'ai le droit d'être quatre jours pas chez moi, et après chez moi. Il ya du voyage qui se prépare, et heu, pour soigner les bêtes, y a pas que ma tante, y a moi aussi."
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu Du Caillou",
        "file": "les_pattes_de_canard.mp3",
        "title": "Les pattes de canard"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu Du Caillou",
        "file": "tatan_elle_fait_des_flans.mp3",
        "title": "Tatan, elle fait des flans"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu Du Caillou",
        "file": "il_ressemble_a_tatan.mp3",
        "title": "Il ressemble à Tatan"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu Du Caillou",
        "file": "mordu.mp3",
        "title": "MORDU"
    },
    {
        "character": "Kadoc",
        "episode": "Livre III, 24 - Les Suppléants",
        "file": "le_caca_des_pigeons_c_est_caca_faut_pas_manger.mp3",
        "title": "Le caca des pigeons c'est caca, faut pas manger"
    },
    {
        "character": "Kadoc",
        "episode": "Livre III, 24 - Les Suppléants",
        "file": "le_poisson_le_petit_poisson.mp3",
        "title": "LE POISSON! LE PETIT POISSON!"
    },
    {
        "character": "Kadoc",
        "episode": "Livre III, 24 - Les Suppléants",
        "file": "pas_du_tout_les_lapins_les_lapins_c_est_gentil.mp3",
        "title": "Pas du tout, les lapins, les lapins c'est gentil"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 60 - Le Jeu du Caillou",
        "file": "a_kadoc.mp3",
        "title": "A Kadoc !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "alors_ca_vient_ptite_bite.mp3",
        "title": "Alors ca vient, p'tite bite !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 23 - La Révolte",
        "file": "bon_ben_revolte.mp3",
        "title": "Bon ben, révolte ?... REVOOOOLTE !!!"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 30 - La Garde Royale",
        "file": "bon_cassez_vous.mp3",
        "title": "Bon, cassez-vous ! Cassez-vous sans déconner j'vous défonce. Vous vous tirez où je vous caillasse la tête !"
    },
    {
        "character": "Loth",
        "episode": "Livre VI, 08 - Lacrimosa",
        "file": "bon_je_la_suis_parce_que_je_suis_tres_amoureux.mp3",
        "title": "Bon ! Moi, je la suis, parce que je suis… Très amoureux !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "cest_le_rendez_vous_des_glandus_la_ou_quoi.mp3",
        "title": "C'est le rendez-vous des glandus là ou quoi ?"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "chui_un_marteau_moi.mp3",
        "title": "Chuis un marteau moi ! Je crame tout moi ! Ma ferme, la sienne, celles des autres, le château, j'vais flamber la moitié de la Bretagne."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 10 - La Chambre",
        "file": "est-ce_que_vous_pouvez_vous_barrer_maintenant.mp3",
        "title": "Est-ce que vous pouvez vous barrer, maintenant ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "jai_pas_envie_de_voir_vos_tronches.mp3",
        "title": "J'ai pas envie de voir vos tronches"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 69 - Feue la Vache de Roparzh",
        "file": "jai_toujours_ete_fascine_par_le_monde_paysan.mp3",
        "title": "J'ai toujours été fasciné par le monde paysan"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 23 - La Révolte",
        "file": "je_pourrais_gueuler_dans_le_cul_dun_poney.mp3",
        "title": "Je gueule, je gueule, j'pourrais gueuler dans le cul d'un poney, qu'ce serait pareil !"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "ben_nous_on_a_cru_que_cetait_la_pour_faire_joli.mp3",
        "title": "Ben nous on a cru que c'était là pour faire joli…"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "bon_je_peux_pas_penser_a_tout_la.mp3",
        "title": "Bon, je peux pas penser à tout, là !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "cest_interessant.mp3",
        "title": "C'est intéressant !"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "ils_sortent_bien_de_quelques_part.mp3",
        "title": "Enfin mais… Ils sortent bien de quelque part, ils sont pas tombés du ciel, si ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "mais_evidemment_que_si.mp3",
        "title": "Mais évidemment que si !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "je_vais_vous_passer_le_gout_du_plein_air_moi.mp3",
        "title": "J'vais vous passer le goût du plein air, moi !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 88 - L'Escorte",
        "file": "la_monstruosite.mp3",
        "title": "Vous êtes marié comme moi vous savez qu'la monstruosité peut prendre des formes très diverses..."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 60 - Le Jeu du Caillou",
        "file": "mais_arretez_de_discutailler_cinq_minutes.mp3",
        "title": "Mais arrêtez de discutailler cinq minutes j'arrive pas à me concentrer !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 38 - Merlin et les Loups",
        "file": "mais_c_est_pas_possible_d_entendre_ca.mp3",
        "title": "Mais c'est pas possible d'entendre ça !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "mon_frere_y_peut_pas_aller_a_l_ecole.mp3",
        "title": "Mon frère y peut pas aller à l'école. Quand on lui explique un machin technique, il s'évanouit."
    },
    {
        "character": "Kay",
        "episode": "Livre I, 08 - Codes et Stratégies",
        "file": "petite_corne.mp3",
        "title": "TRUUU-uuuut !"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "restez_pas_plante_la_comme_un_cepe.mp3",
        "title": "Ne restez pas planté là comme un cèpe, pointez-vous !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 25 - Séli et les rongeurs",
        "file": "vous_admettrez_que_vous_etes_hors_normes.mp3",
        "title": "Non mais il y a des fois, vous admettrez que vous êtes hors-norme."
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 10 - La Chambre",
        "file": "vous_voulez_que_je_vous_degage_la_nuque_a_la_serpette.mp3",
        "title": "Non mais vous surchauffez pas un peu du citron, non ?! Vous voulez que j'vous dégage la nuque à la serpette ?"
    },
    {
        "character": "Titus Nipius Glaucia",
        "episode": "Livre VI, 04 - Arturi Inquisitio",
        "file": "tu_la_fermes_definitivement.mp3",
        "title": "Toi tu fermes ta gueule. Tu la fermes définitivement, tu fermes ta gueule définitivement !"
    },
    {
        "character": "Goustan",
        "episode": "Livre VI, 02 - Le Centurion",
        "file": "bataille_de_fions.mp3",
        "title": "Et bien voilà, bataille de fions"
    },
    {
        "character": "Caius",
        "episode": "Livre III, 07 - Le Déserteur",
        "file": "stand_de_crepes.mp3",
        "title": "Oui mais je bosse le jour moi. J'suis dans l'armée, j'tiens pas un stand de crêpes."
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre III, 42 - Le Dialogue de Paix II",
        "file": "fort_en_pomme_1.mp3",
        "title": "Fort en pommes ? (1)"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre III, 42 - Le Dialogue de Paix II",
        "file": "fort_en_pomme_2.mp3",
        "title": "Fort en pommes !? (2)"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre III, 42 - Le Dialogue de Paix II",
        "file": "on_est_forts.mp3",
        "title": "On est forts ! ... En pommes."
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre III, 42 - Le Dialogue de Paix II",
        "file": "qu-est_ce_dire_que_ceci.mp3",
        "title": "Qu'est-ce à dire que ceci ?"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre III, 42 - Le Dialogue de Paix II",
        "file": "nuo_pusso_volo.mp3",
        "title": "Nuo pusso volo, tannipo mayo. Uon pusso volo tandullo tullo. Tannasso ! Tannamalasso ! Tannasso ! Les oiseaux petits."
    },
    {
        "character": "Guethenoc",
        "episode": "Livre III, 36 - Feue La Poule de Guethenoc",
        "file": "pique_diagonale.mp3",
        "title": "Moi je bondis comme ça, là. Après je vous arrive dessus en piqué diagonal. Et là c'est l'hymne à la cruauté, attention hein. Un autel dressé au culte de la barbarie."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 88 - L'éscorte",
        "file": "2_3_poils_de_Q.mp3",
        "title": "A 2-3 poils de cul"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 81 - Polymorphie",
        "file": "a_voui_vous_avez_raison.mp3",
        "title": "Ah voui, c'est ça, vous avez raison hein"
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 11 - Ablutions",
        "file": "a_plus_tard.mp3",
        "title": "A plus tard"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 39 - Le Cas yvain",
        "file": "avez_de_la_chance.mp3",
        "title": "Vous avez de la chance hein"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 97 - Agnus Dei",
        "file": "charmant.mp3",
        "title": "Charmant !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 89 - Tel Un Chevalier",
        "file": "comment.mp3",
        "title": "Comment ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 07 - Des Nouvelles du Monde",
        "file": "enquille.mp3",
        "title": "Oui, bon allez ! Enquille !"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre I, 96 - La Quête des Deux Renards",
        "file": "epique.mp3",
        "title": "Je sens qu'ça va encore être épique"
    },
    {
        "character": "Séli",
        "episode": "Livre I, 02 - La Tarte aux Myrtilles",
        "file": "et_alors_faut_un_permis.mp3",
        "title": "Et alors faut un permis ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 88 - L'Escorte",
        "file": "et_puis_quoi_encore.mp3",
        "title": "Et puis quoi encore ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous Les Verrous",
        "file": "evidemment_quelquun.mp3",
        "title": "Evidemment qu'y a quelqu'un !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 23 - La potion de Fécondité",
        "file": "fournis_notice.mp3",
        "title": "Ma parole, des engins comme vous ça devrait être fournis avec une notice"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 87 - Retour de Campagne",
        "file": "ah_cest_ca.mp3",
        "title": "Ah c'est ça !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 67 - La Kleptomane",
        "file": "intro_comaque.mp3",
        "title": "L'intro est comaque"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 46 - Le Code de Chevalerie",
        "file": "jvous_fait_confiance.mp3",
        "title": "Non non non, j'vous fais confiance"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 93 - Unagi",
        "file": "la_dedans_carbure.mp3",
        "title": "Là dedans par contre ça carbure"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 60 - Le Prodige du Fakir",
        "file": "la_gerbe.mp3",
        "title": "J'vous raconte pas la gerbe"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 25 - Le Sacrifice",
        "file": "ptetre_une_connerie.mp3",
        "title": "Ptet fait une connerie mo"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 76 - Choc Frontal",
        "file": "quand_meme_raide.mp3",
        "title": "M'enfin, elle est quand même raide celle-là"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 80 - Les Volontaires",
        "file": "sans_deconner.mp3",
        "title": "Non sans déconner ?"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "meteo.mp3",
        "title": "Météo"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "assiette_fromage.mp3",
        "title": "Arthour, pas changer assiette pour fromage"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "ave_cesar.mp3",
        "title": "Ave Cesar !"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "tres_bien.mp3",
        "title": "Très bien"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "cuillere_2.mp3",
        "title": "Cuillère (2)"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 12 - La Délégation Maure",
        "file": "lache_une_caisse.mp3",
        "title": "Si il lache une caisse ça le fait ou pas ?"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "et_cest_de_la_merde.mp3",
        "title": "Et c'est de la merde"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "coup_de_beche.mp3",
        "title": "Coup de bèche dans la tête"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 79 - La Botte Secrète II",
        "file": "merci_de_rien.mp3",
        "title": "Merci de rien, au revoir messieurs dames"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 92 - La Restriction",
        "file": "pauvre_conne.mp3",
        "title": "Pauvre conne !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 98 - La Frange Romaine",
        "file": "quequette.mp3",
        "title": "C'est passé à ça d'la quequette"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 52 - Excalibur et le Destin",
        "file": "gras_du_cul.mp3",
        "title": "Je vais vous découper le gras du cul, ça vous fera ça de moins à trimballer"
    },
    {
        "character": "Karadoc",
        "episode": "Livre III, 93 - Le Législateur",
        "file": "joie_de_vivre.mp3",
        "title": "La joie de vivre et le jambon"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 46 - Le Cadeau",
        "file": "ferme_ta_gueule.mp3",
        "title": "Ferme ta gueule"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 48 - Les Chiens de Guerre",
        "file": "coup_de_pied_aux_poules.mp3",
        "title": "Moi j'en ai marre de toujours donner des coups de pied aux poules"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 42 - La Fête du Printemps",
        "file": "cest_prodigieux.mp3",
        "title": "Non mais c'est incroyable. J'ai l'impression de bouffer de la terre avec de la bouse et du gravier, ça sent le poulailler, mais c'est du céleri et des oignons, c'est prodigieux."
    },
    {
        "character": "Merlin",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "pas_dalcool.mp3",
        "title": "En plus il n'y a pas d'alcool"
    },
    {
        "character": "Jacca",
        "episode": "Livre I, 21 - La Taxe Militaire",
        "file": "il_trouverait_meme_pas_sa_bite_pour_pisser.mp3",
        "title": "Mais vous vous foutez de moi ! Il a au moins 95 ans, il a une jambe raide, il est tellement bigleux qu'il trouverait même pas sa bite pour pisser !"
    },
    {
        "character": "Grüdü",
        "episode": "Livre I, 22 - La Queue du Scorpion",
        "file": "mi_ours_mi_scorpion.mp3",
        "title": "En plus y'en avait un il était mi-ours, mi-scorpion et re-mi-ours derrière !"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 38 - Le Rassemblement du Corbeau II",
        "file": "cest_que_cest_pas_une_blague.mp3",
        "title": "C'est pas que c'est pas drôle, c'est que c'est pas une blague"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "fleur_en_bouquet.mp3",
        "title": "La fleur en bouquet fâne... et jamais ne renait !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 11 - Dîner Dansant",
        "file": "je-l-ai-pas-dit-fort.mp3",
        "title": "Je l'ai pas dit fort"
    },
    {
        "character": "Loth",
        "episode": "Livre V, 13 - Les Dauphins",
        "file": "votre_existence_est_merdique.mp3",
        "title": "Parce que votre existence est merdique mon pauvre ami, vous avez l'œil qui brille à chaque fois qu'un oiseau pète, c'est triste à voir. Ça fait des années que vous menez un train de vie de noix de Saint-Jacques, alors évidemment, un message qui annonce la visite d'un imbécile porteur de bonnes nouvelles, c'est déjà un petit festival pour vous ! J'suis sûr que vous vous êtes peigné pour l'occasion !"
    },
    {
        "character": "Anna",
        "episode": "Livre V, 30 - La Supplique",
        "file": "vous-etes-une-gigantesque-tarlouze.mp3",
        "title": "Vous êtes une gigantesque tarlouze"
    },
    {
        "character": "Appius Manilius",
        "episode": "Livre VI, 06 - Nuptiae",
        "file": "j-ai-cherche-la-merde.mp3",
        "title": "En fait j'en ai pris deux, mais euh... j'ai cherché la merde"
    },
    {
        "character": "Spurius Cordius Frontiniu",
        "episode": "Livre VI, 06 - Nuptiae",
        "file": "comment_peut_on_arriver_a_un_grade_aussi_eleve.mp3",
        "title": "Comment peut-on arriver à un grade aussi élevé en étant aussi naïf ?"
    },
    {
        "character": "Merlin",
        "episode": "Livre III, 04 - Le Renfort Magique",
        "file": "j-ai-tout-entendu.mp3",
        "title": "J'ai tout entendu et c'est honteux !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 53 - L'Absent",
        "file": "remonte-ton-slibard.mp3",
        "title": "Et toc ! Remonte ton slibard Lothard !"
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 08 - Morituri",
        "file": "faut-y-aller-a-la-zob.mp3",
        "title": "Quand on n'a pas de technique, faut y aller à la zob"
    },
    {
        "character": "Perceval",
        "episode": "Livre IV, 71 - Perceval Fait Raitournelle",
        "file": "c-est-les-autres-qui-sont-cons.mp3",
        "title": "C'est pas moi qui explique mal, c'est les autres qui sont cons !"
    },
    {
        "character": "Séli",
        "episode": "Livre I, 50 - Les Nouveaux Frères",
        "file": "cest_pas_des_fleches.mp3",
        "title": "Ah bah c'est pas des flèches"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "ah_bravo_bah_vous_parlez_d_un_hero.mp3",
        "title": "Ah bravo ! Alors vous parlez d'un héro !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 20 - La Dent de Requin",
        "file": "ah_non_ca_c_est_que_nous.mp3",
        "title": "Ah non, ça c'est que nous. Parce qu'il faut être capable de passer pour des cons en un temps record. Ah non, là dessus on a une avance considérable."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "ah_parce_que_c_est_la_seule_alternative_que_vous_me_proposez.mp3",
        "title": "Parce que c'est la seule alternative que vous me proposez ! Rien branler de la journée ou des concours de pets ?!"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 46 - Le Code de Chevalerie",
        "file": "alors_des_qu_il_s_agit_d_aller_se_dorer_les_miches_en_armorique.mp3",
        "title": "Alors dès qu'il s'agit d'aller s'dorer les miches en Armorique pour demander aux filles si elles ont pas vu le cul de Lulu alors là, là oui y a des volontaires !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 01 - Heat",
        "file": "animaux_de_la_foret.mp3",
        "title": "Animaux de la forêt !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 16 - Le Banquet des Chefs",
        "file": "bohort_arreter_de_vous_vexer_sans_arret_comme_une_grosse_dinde.mp3",
        "title": "Bohort arrêtez de vous vexer sans arrêt comme une grosse dinde ! On vous dit qu'c'est politique !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 28 - La Botte Secrète",
        "file": "c_est_cotelette_que_vous_comprenez_pas.mp3",
        "title": "C'est côtelette que vous ne comprenez pas ?"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 43 - La Coccinelle de Madenn",
        "file": "chaque_fois_que_je_vais_a_un_balloche_je_picole_je_discute.mp3",
        "title": "À chaque fois qu'j'vais à un baloche, j'picole, j'discute, trois mois après y'a toujours un type qui débaroule avec sa fille enceinte."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 35 - Ambidextrie",
        "file": "de_tout_facon_on_dit_le_nord_selon_comment_on_est_tourne_ca_change_tout.mp3",
        "title": "De tout façon on dit le Nord, selon comment on est tourné ça change tout !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 41 - Arthur et les Ténèbres",
        "file": "dites_tout_de_suite_que_j_ai_des_idees_de_tocard.mp3",
        "title": "Dites tout de suite que j'ai des idées de tocard."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 46 - Le Code de Chevalerie",
        "file": "faut_que_je_retourne_a_la_ferme_de_mes_vieux.mp3",
        "title": "Faut qu'j'retourne à la ferme de mes vieux, y a ma grand-mère qu'à glissé sur une bouse, c'est l'vrai merdier !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "fier_je_vais_l_envoyer_trois_mois_a_poil_dans_la_foret.mp3",
        "title": "Fier ?! J'vais l'envoyer trois mois à poil dans la forêt à bouffer des asticots et des racines, et puis j'vous garantis que quand il reviendra il fera moins de poêmes hein !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "fils_d_unijambiste.mp3",
        "title": "Fils d'unijambiste"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 44 - Patience dans la Plaine",
        "file": "il_ne_comprennent_jamais_le_code.mp3",
        "title": "Non mais ils comprennent jamais le code"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 31 - Basidiomycètes",
        "file": "j_ai_pas_eu_le_temps_d_enlever_mon_armure.mp3",
        "title": "J'ai pas eu le temps d'enlever mon armure."
    },
    {
        "character": "Le Barde",
        "episode": "Livre I, 07 - Des Nouvelles du Monde",
        "file": "je_l_ai_perdu.mp3",
        "title": "J'l'ai perdu. J'l'ai perdu, je, j'l'ai perdu"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 18 - En Forme de Graal",
        "file": "je_sens_que_ce_va_encore_etre_capital.mp3",
        "title": "Je sens que ça va encore être capital."
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 20 - La Dent de Requin",
        "file": "je_trouve_qu_on_nous_prend_un_peu_trop_pour_des_cons.mp3",
        "title": "Je trouve qu'on nous prend un peu trop pour des cons en ce moment !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 37 - La Romance de Lancelot",
        "file": "mais_qu_est_ce_qui_vous_prend_ca_va_pas_vous_etes_dingue.mp3",
        "title": "Mais qu'est-ce qui vous prend, ça va pas, vous êtes dingue !?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 09 - Le Maître d'armes",
        "file": "moi_depuis_ce_matin_je_me_fait_traiter_de_gonzesse.mp3",
        "title": "Moi depuis ce matin j'me fais traiter de gonzesse, j'en fais pas tout un cake !"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 31 - Basidiomycètes",
        "file": "moi_il_faut_que_j_enleve_mon_armure.mp3",
        "title": "Moi il faut que j'enlève mon armure sinon il va s'passer quelque chose d'atroce"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 12 - Le Sixième Sens",
        "file": "non_taisez_vous.mp3",
        "title": "Non, taisez-vous. Pfff taisez-vous. Taisez vous parce que là ça… pfiut là ça chut vous voyez… voilà…"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 45 - Le Oud",
        "file": "oh_et_puis_j_en_ai_marre.mp3",
        "title": "Oh et puis j’en ai marre ! EH OH, ÇA VA PAS BIENTÔT FINIR NON ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 15 - Les Défis de Merlin",
        "file": "ok_on_va_arreter_le_tire_avec_les_defis.mp3",
        "title": "Ok, on va arrêter le tir avec les défis."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 02 - La Tarte aux Myrtilles",
        "file": "on_plaisante_on_plaisante.mp3",
        "title": "On plaisante, on plaisante..."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 04 - Le Chevalier Mystère",
        "file": "pas_foutu_de_savoir_son_nom.mp3",
        "title": "Pas foutu d'savoir son nom !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 38 - Merlin et les Loups",
        "file": "putain_faut_vraiment_qu_on_se_groulle.mp3",
        "title": "Putain faut vraiment qu'on s'grouille !"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre I, 46 - Le Code de Chevalerie",
        "file": "quies.mp3",
        "title": "Quies… (ancien Celte)"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 27 - Le Retour de Judée",
        "file": "rangez_moi_ca_debile_la_table_ronde_c_est_pas_une_fete_de_l_artisanat.mp3",
        "title": "Rangez-moi ça débile. La table ronde c'est pas une fête de l'artisanat"
    },
    {
        "character": "Azénor",
        "episode": "Livre I, 48 - Azénor",
        "file": "sans_etre_totalement_repoussant_il_n_y_a_pas_de_quoi_bousculer_une_charette.mp3",
        "title": "Sans être totalement repoussant il n'y a pas de quoi non plus bousculer une charrette."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 01 - Heat",
        "file": "scorpion_entoure_par_le_feu.mp3",
        "title": "Non ! Il faut faire comme avec les scorpions qui se suicident quand ils sont entourés par le feu ! Faut faire un feu en forme de cercle autour d’eux, comme ça ils se suicident, pendant que nous on fait l’tour, et on lance de la caillasse de l’autre côté, pour brouiller. Non ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 61 - Un Bruit dans la Nuit",
        "file": "si_j_etais_tombe_sur_un_faisant.mp3",
        "title": "Si j'étais tombé sur un faisan je serais pas en train de me la péter comme ça."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 47 - Létal",
        "file": "sinon_ce_que_je_peux_vous_proposer_on_attache_le_condamne.mp3",
        "title": "Sinon c'que j'peux vous proposer : on attache le condamné, et on le balance sur un nid d'frelons. C'est propre c'est sain. C'est rien qu'du naturel."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 31 - Basidiomycètes",
        "file": "un_plan_d_attaque_minute_au_poil_de_fion.mp3",
        "title": "Un plan d'attaque minuté au poil de fion, le double d'effectif de ceux d'en face ! Manque de bol, les Seigneurs Perceval et Karadoc s'en mèlent et on rentre chez nous comme des clodos. Avec la chiasse en prime ! Qu'est-ce qu'ils sont cons !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 43 - La Coccinelle de Madenn",
        "file": "une_fois_a_une_execution_je_m_approche_d_une_fille.mp3",
        "title": "Une fois à une exécution j'm'approche d'une fille, pour rigoler j'lui fait \"vous êtes de la famille du pendu ?\". C'était sa soeur. Bonjour l'approche."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 54 - Le Serpent Géant",
        "file": "ils_se_barrent_en_mission_pendant_trois_mois_et_ils_reviennent_avec_une_anguille.mp3",
        "title": "Ils se barrent en mission pendant trois mois et ils reviennent avec une anguille ?"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 54 - Le Serpent Géant",
        "file": "attendez_il_faut_que_ca_soit_vrai_tout_ce_qu_on_dit_la.mp3",
        "title": "Attendez... il faut que ça soit vrai tout ce qu'on dit la ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 55 - Guenièvre et les Oiseaux",
        "file": "bah_si_il_n_y_avait_que_les_oiseaux_elle_est_a_moitie_givree_de_toute_facon_on_ne_peut_pas_tout_relever_non_plus.mp3",
        "title": "Bah si il n'y avait que les oiseaux elle est à moitié givrée de toute façon. On ne peut pas tout relever non plus !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 56 - Le Dernier Empereur",
        "file": "centurion_caius_camilus_lulululu.mp3",
        "title": "Centurion Caius Camilus lulululu"
    },
    {
        "character": "Caius",
        "episode": "Livre I, 56 - Le Dernier Empereur",
        "file": "mais_si_on_fait_marrer_tout_le_monde.mp3",
        "title": "Mais si on fait marrer tout le monde avec nos chenilles à la purée de fraise, nos couilles d'oursin aux amandes, j'sais pas quelles autres saloperies là."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 57 - Perceval Relance de Quinze",
        "file": "cest_facile_on_peut_jouer_soit_avec_des_haricots_soit_avec_des_lentilles.mp3",
        "title": "C’est facile. On peut jouer soit avec des haricots, soit avec des lentilles. Le premier qui annonce la mise, il dit mettons : \"lance de seize\" ou \"lance de trente-deux\" ou une quadruplée comme on appelle, c’est une \"lance de soixante-quatre\". Parce qu’on annonce toujours de seize en seize, sauf pour les demi-coups. Là, celui qui est à sa gauche, soit il monte au moins de quatre, soit il passe il dit : \"passe-grelot\", soit il parie qu’il va monter de six ou de sept et il peut tenter une grelottine. À ce compte-là, il joue pas, il attend le tour d’après, et si le total des mises des deux autres suffit pas à combler l’écart, il gagne sa grelottine et on recommence le tour avec des mises de dix-sept en dix-sept. (…) Donc mettons le suivant, il annonce une quadruplée, donc là elle vaut soixante-huit, il peut contrer ou il se lève et il tape sur ses haricots en criant \"grelotte, ça picote !\" et il tente la relance jusqu’au tour d’après."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 58 - Le Coup d'Épée",
        "file": "au_gros_sel_qu_est_ce_que_c_est_ces_conneries_vous_me_prenez_pour_une_epaule_d_agneau.mp3",
        "title": "Au gros sel ? Qu'est-ce que c'est ces conneries ? Vous me prenez pour une épaule d'agneau ?"
    },
    {
        "character": "Calogrenant",
        "episode": "Livre I, 59 - La Jupe de Calogrenant",
        "file": "considerer_que_je_suis_officiellement_cul_nu.mp3",
        "title": "Mais une tenue officielle, vous n'avez qu'à considérer que je suis officiellement cul nu !"
    },
    {
        "character": "Gauvain",
        "episode": "Livre I, 60 - Le Prodige du Fakir",
        "file": "et_a_un_moment_le_sorcier_s_est_mis_a_nous_menacer_avec_ses_parties_genitales.mp3",
        "title": "Et à un moment, le sorcier s'est mis à nous menacer avec ses parties genitales"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 60 - Le Prodige du Fakir",
        "file": "il_avait_une_touffe_de_cheveux_comme_ca_un_vieux_moisi_tout_gueze_a_poil_dans_la_neige.mp3",
        "title": "Il avait une touffe de cheveux comme ça, un vieux moisi tout gueze à poil dans la neige !"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 60 - Le Prodige du Fakir",
        "file": "avec_sa_couille.mp3",
        "title": "Avec sa couille !"
    },
    {
        "character": "Bohort",
        "episode": "Livre I, 61 - Un Bruit dans la Nuit",
        "file": "a_moi.mp3",
        "title": "A MOI !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre I, 62 - Feu l'Âne de Guethenoc",
        "file": "attention_attention_a_un_moment_il_y_a_des_granges_qui_vont_se_mettre_a_flamber_il_faudra_pas_demander_d_ou_sa_vient.mp3",
        "title": "Attention attention ! Il va arriver un moment il y a des granges qui vont se mettre à flamber il faudra pas demander d'où ça vient !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 64 - Le chaudron rutilant",
        "file": "il_m_aura_fait_chier_jusqu_au_bout_celui_la.mp3",
        "title": "Il m'aura fait chier jusqu'au bout celui-là !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre I, 68 - Le Pain",
        "file": "mais_c_est_une_honte_d_entendre_des_trucs_comme_ca.mp3",
        "title": "Mais c'est une honte d'entendre des trucs comme ça !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 69 - La mort le Roy Artu",
        "file": "cest_qui_tout_ces_cons.mp3",
        "title": "C'est qui tout ces cons ?"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 71 - Un Roi à la Taverne",
        "file": "dis_donc_machine_si_tu_allais_voir_a_la_table_du_fond_si_on_y_ait.mp3",
        "title": "Dis donc machin, si t'allais voir à la table du fond si on y est ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 71 - Un Roi à la Taverne",
        "file": "et_vous_bande_de_cons.mp3",
        "title": "Et vous bande de cons !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 72 - Les Fesses de Guenièvre",
        "file": "pfff_c_est_pour_ca_que_je_pane_rien_aux_livres_moi_ca_veut_pas_dire_ce_qu_il_y_a_marque.mp3",
        "title": "Pfff ! C'est pour ça qu'j'pane rien aux livres moi, ça veut pas dire ce qu'il y a marqué."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 74 - Guenièvre et l'Orage",
        "file": "nan_mais_c_est_pas_possible_elle_me_foutra_pas_la_paix.mp3",
        "title": "Nan mais c'est pas possible elle me foutra pas la paix !"
    },
    {
        "character": "Narces",
        "episode": "Livre I, 75 - Eunuques et Chaud lapins",
        "file": "rooo_bon_alors_on_fait_venir_les_poulettes_ou_quoi.mp3",
        "title": "ROOO ! Bon, alors, on fait venir les poulettes ou quoi ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 77 - Le Forage",
        "file": "alors_si_j_ai_bien_resume_le_truc_vous_allez_creuser_trois_pieds_et_demi_sur_toute_la_bretagne.mp3",
        "title": "Alors si j'veux bien résumer l'truc, vous allez creuser trois pieds et demi sur toute la Bretagne, jusqu'à c'que vous tombiez sur le Graal, c'est ça ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 78 - Le Discobole",
        "file": "cest_tellement_facile_que_je_vais_peut_etre_systematise_le_processus.mp3",
        "title": "C'est tellement facile que j'vais p'tet systématiser le processus. Parce qu'y'a pas qu'la statue qui m'emmerde."
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 79 - L'Expurgation de Merlin",
        "file": "tais_toi_ta_gueule_tais_toi.mp3",
        "title": "Tais toi ! Ta gueule ! Tais toi !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 82 - Décibels Nocturnes",
        "file": "ah_nan_mais_quand_on_est_pas_habitue_c_est_drolement_impressionnant_la_magie.mp3",
        "title": "Ah nan mais quand on est pas habitué c'est drôlement impressionnant la magie !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 82 - Décibels Nocturnes",
        "file": "un_jour_je_vais_lui_fumer_sa_gueule_a_ce_connard.mp3",
        "title": "Un jour j'vais lui fumer sa gueule à c'connard."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 85 - La Blessure Mortelle",
        "file": "ah_mais_arretez_de_gueuler_comme_un_con.mp3",
        "title": "Ah mais arrêtez d'gueuler comme un con !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 88 - L'Escorte",
        "file": "bon_bah_aller_on_demarre_et_ouvrez_les_echauguettes.mp3",
        "title": "Bon bah aller on démarre. Et ouvrez les échauguettes, j'ai pas envie de répéter."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 88 - L'Escorte",
        "file": "ah_qu_est_ce_que_vous_voulez_mon_petit_bohort.mp3",
        "title": "Ah qu'est-ce que vous voulez mon petit Bohort, entre son épée qui fait de la lumière, son Merlin qui fait pleuvoir des grenouilles et sa Dame du Lac qui se prend pour une truite, il ne lui manque plus qu'un numéro de trapèze au roi des bretons."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "ah_non_la_aujourd_hui_ca_passera_pas.mp3",
        "title": "Ah non moi là aujourd'hui ça passera pas."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "j_aimerais_bien_qu_on_commence_a_me_considerer_en_tant_que_tel.mp3",
        "title": "J'aimerais bien qu'on commence à me considérer en tant que tel."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "je_vous_disais_que_j_etais_victime_des_colifiches.mp3",
        "title": "J'vous disais que j'étais victime des colifichés et qu'il faudrait qu'on commence à me considérer en tant que tel."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "non_mais_je_sens_bien_que_vous_essayer_de_me_dire_quelque_chose.mp3",
        "title": "Non mais je sens bien que vous essayer de me dire quelque chose, mais c'est de vous la phrase ou vous l'avez entendu ça ? \"colifiché\" par exemple, qu'est-ce que c'est pour vous ? comment ça, comment vous vous le représentez, \"colifiché\" ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 89 - Tel un Chevalier",
        "file": "bon_bah_je_vais_voir_ce_que_je_peux_faire.mp3",
        "title": "Bon bah je vais voir ce que je peux faire."
    },
    {
        "character": "Guenièvre",
        "episode": "Livre I, 90 - La Pâte d'Amande",
        "file": "ca_va_oui_ca_va_vous_etes_content.mp3",
        "title": "ça va oui, ça va, vous êtes CONTENT !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 90 - La Pâte d'Amande",
        "file": "je_crois_pas_que_vous_soyez_le_symbole_de_la_nation_bretonne.mp3",
        "title": "J'crois pas qu'vous soyez le symbole de la nation bretonne."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 90 - La Pâte d'Amande",
        "file": "ah_ah_mais_vous_etes_marteau_et_regardez_ca_ca_pisse_le_sang.mp3",
        "title": "Ah ! Ah, mais vous êtes marteau ?! Et regardez ça, ça pisse le sang !"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 91 - La Fureur du Dragon",
        "file": "il_nous_a_chie_dessus.mp3",
        "title": "Il nous a chié d'ssus."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 91 - La Fureur du Dragon",
        "file": "oui_enfin_je_me_comprends.mp3",
        "title": "Oui enfin... j'me comprends."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 92 - Vox Populi",
        "file": "oui_oh_ca_va_je_connais_le_couplet_on_est_fatigue_on_est_fatigue_vous_me_le_cancane_depuis_midi.mp3",
        "title": "Oui oh ça va, ça va, j'connais le couplet : \"On est fatigué, on est fatigué\", vous me le cancanez depuis midi."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 93 - Unagi",
        "file": "non_psychologique_c_est_tout_ce_qui_est_a_la_campagne.mp3",
        "title": "Non psychologique c'est tout ce qui est à la campagne non ?"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 93 - Unagi",
        "file": "ah_ouais_je_l_ai_fait_trop_fulgurant_la_ca_va.mp3",
        "title": "Ah ouais je l'ai fait trop fulgurant là. Ça va ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 94 - L'Éclaireur",
        "file": "parce_que_la_quite_a_se_faire_reperer_on_prendrait_moins_de_risque_a_faire_venir_un_orchestre.mp3",
        "title": "Parce que là quitte à se faire repérer, on prendrait moins de risque à faire venir un orchestre."
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 94 - L'Éclaireur",
        "file": "j_ai_fais_pile_comme_vous_avez_dis_tout_au_feu_de_bois.mp3",
        "title": "J'ai fait pile comme vous avez dit, tout au feu de bois."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 97 - Agnus Dei",
        "file": "la_vache_ca_daube_la_dedans_il_y_a_un_chat_qui_est_creve_ou_quoi.mp3",
        "title": "La vache, ça daube là-dedans ! Il y a un chat qui est crevé ou quoi ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "vous_allez_me_foutre_le_camp_espece_de_con.mp3",
        "title": "Vous allez me foutre le camp espèce de con !?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "mais_qu_est_ce_que_vous_voulez_que_ca_me_foute.mp3",
        "title": "Mais qu'est-ce que vous voulez que ça me foute !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "me_parler_a_cette_heure_ci_vous_voulez_mon_pied_au_cul.mp3",
        "title": "Me parler ? À c't'heure-ci ? Vous voulez mon pied au cul ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "ah_si_moi_j_irai_me_recoucher_avant_de_prendre_un_pain.mp3",
        "title": "Ah si, ah moi j'serais vous j'irai me recoucher vite fait avant de m'prendre un pain."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "bah_je_sais_pas_me_lacher_la_grappe_par_exemple.mp3",
        "title": "Bah je sais pas ? Me lâcher la grappe par exemple ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "mais_qu_est_ce_que_vous_voulez_que_ca_me_foute_vos_conneries.mp3",
        "title": "Mais qu'est-ce que vous voulez que ça me foute vos conneries ?!"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "mais_mariez_vous_avec_qui_vous_voulez_et_allez_crever.mp3",
        "title": "Mais mariez-vous avec qui vous voulez et allez crever !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "mais_qu_est_ce_que_j_en_ai_a_foutre_vous_pourriez_bien_vous_marier_avec_une_chevre_si_ca_vous_chante.mp3",
        "title": "Mais qu'est-ce que j'en ai a foutre ?! Mais vous pourriez bien vous marier avec une chèvre si ça vous chante !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "et_puis_alors_mon_petit_pote_si_vous_en_tenez_une_qui_veux_se_marier_avec_vous.mp3",
        "title": "Et puis alors mon petit pote si vous en tenez une qui veut vraiment se marier avec vous, rappelez-vous que c'est inespéré et sautez sur l'occasion avant qu'elle change d'avis !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "tout_le_monde_s_en_branle_moi_le_premier.mp3",
        "title": "Tout le monde s'en branle, moi le premier !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "j_en_ai_rien_a_foutre.mp3",
        "title": "J'en ai rien à foutre !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 98 - Le Tourment",
        "file": "rien_a_carrer.mp3",
        "title": "Rien à carrer !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 99 - La Retraite",
        "file": "mais_qu_est_ce_que_vous_me_bavez_encore.mp3",
        "title": "Mais qu'est-ce que vous me bavez encore !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 99 - La Retraite",
        "file": "vous_devriez_commencer_par_organiser_le_merdier_que_vous_avez_la_dedans.mp3",
        "title": "Vous devriez déjà commencer par organiser le merdier que vous avez la dedans !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 99 - La Retraite",
        "file": "qu_est_ce_que_vous_voulez_savoir_allez_vous_vous_magner_le_tronc_maintenant.mp3",
        "title": "Qu'est-ce que vous voulez savoir ? Allez, vous vous magnez l'tronc mainenant ! Vous m'dites c'que vous voulez et vous faites un effort pour que j'pane au moins le sens de votre phrase ! Je commence à en avoir plein le dos et d'choper des maux de tête à répétition à force de jamais piger un broc de c'que vous racontez ! Alors vous reprenez d'puis l'début, avec une tournure simple et directe ou vous ramassez une tarte, c'est clair ça ?!"
    },
    {
        "character": "Belt",
        "episode": "Livre VI, 07 - Arturus Rex",
        "file": "regardez_moi_cette_meule.mp3",
        "title": "Regardez-moi cette meule ! J'ai affiné cette saloperie de frometon pendant des mois et des mois, résultat, il est dégueulasse. Pourquoi ? Parce que je suis nul en fromage ! Merde !"
    },
    {
        "character": "Belt",
        "episode": "Livre VI, 07 - Arturus Rex",
        "file": "regardez_moi_ce_petit_navet.mp3",
        "title": "Regardez moi ce petit navet ! A quelle heure on doit se lever nous le matin ? On nous en colle jusque là, ras la gueule ras la gueule ras la gueule ! Et un jour qu'est ce qu'il va se passer ? Patatrac !"
    },
    {
        "character": "Roparzh",
        "episode": "Livre VI, 07 - Arturus Rex",
        "file": "c_est_maintenant_quil_faut_se_secouer.mp3",
        "title": "Mais justement c'est maintenant qu'il faut se secouer les rognons, sinon ça part tout à volo."
    },
    {
        "character": "Loth",
        "episode": "Livre VI, 08 - Lacrimosa",
        "file": "tsoin-tsoin.mp3",
        "title": "Nan... mais pas vous ! Vous, vous pouvez rester tsoin-tsoin comme d'habitude."
    },
    {
        "character": "Loth",
        "episode": "Livre VI, 08 - Lacrimosa",
        "file": "petit_ton_decale.mp3",
        "title": "J'aime assez ce petit ton décalé..."
    },
    {
        "character": "Loth",
        "episode": "Livre VI, 08 - Lacrimosa",
        "file": "cuit_les_boules.mp3",
        "title": "Ça m'a littéralement cuit les boules !"
    },
    {
        "character": "Loth",
        "episode": "Livre V, 02 - Miserere Noire",
        "file": "tres_en_colere.mp3",
        "title": "Misa brevis et spiritus maxima. Ça veut rien dire, mais je suis très en colère contre moi-même."
    },
    {
        "character": "Loth",
        "episode": "Livre V, 14 - Vae Soli",
        "file": "pas_envie_de_participer.mp3",
        "title": "Ah, mais c’est pas possible, ça ! J’ai pas envie, de participer ! À rien ! C’est pas mon genre, de participer ! Jamais je participerai ! À part à vos obsèques, bande de cons !"
    },
    {
        "character": "Loth",
        "episode": "Livre V, 01 - Les Repentants",
        "file": "sur_de_son_coup.mp3",
        "title": "Quand on veut être sûr de son coup, Seigneur Dagonet… on plante des navets. On ne pratique pas le putsch."
    },
    {
        "character": "Loth",
        "episode": "Livre IV, 08 - Dagonet et le Cadastre",
        "file": "parfaitement_antipathique.mp3",
        "title": "Et vous êtes parfaitement antipathique. D'ailleurs j'vous aime pas moi non plus, comme quoi, voyez ?"
    },
    {
        "character": "Loth",
        "episode": "Livre IV, 08 - Dagonet et le Cadastre",
        "file": "demi_journee_vous_attend.mp3",
        "title": "C'est à dire qu'ça fait un peu une demi-journée qu'on vous attend, mais ça fait rien"
    },
    {
        "character": "Loth",
        "episode": "Livre IV, 08 - Dagonet et le Cadastre",
        "file": "ici_chez_les_salopards.mp3",
        "title": "Vous pouvez parler en toute franchise : pour faire court, vous êtes ici chez les salopards, hein, c'est admis. On n'a pas des idées bien jojo, et on a pas peur de le dire. On fomente, on rénégate, on laisse libre cours à notre fantaisie"
    },
    {
        "character": "Loth",
        "episode": "Livre IV, 08 - Dagonet et le Cadastre",
        "file": "peigne_zizi.mp3",
        "title": "Non, pour nous, c'est un peigne zizi, voilà"
    },
    {
        "character": "Galessin",
        "episode": "Livre I, 51 - Enluminures",
        "file": "parle_de_travers_cureton.mp3",
        "title": "Moi il me semble qu'il nous parle bien de travers, le cureton, aujourd'hui !"
    },
    {
        "character": "Galessin",
        "episode": "Livre IV, 08 - Dagonet et le Cadastre",
        "file": "oui_ben_non.mp3",
        "title": "Oui... Ben non !"
    },
    {
        "character": "Anna",
        "episode": "Livre V, 32 - L'Odyssée d'Arthur",
        "file": "signe_de_vouloir_discuter.mp3",
        "title": "Excusez-moi, est-ce qu'à un seul moment j'aurais, par mégarde, donné le moindre signe de vouloir discuter avec vous ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 02 - Les Tartes aux Myrtilles",
        "file": "difference_concrete_avec_des_briques.mp3",
        "title": "Sans vouloir la ramener, la seule différence concrète avec des briques, c'est que vous appelez ça des tartes !"
    },
    {
        "character": "Merlin",
        "episode": "Livre I, 15 - Les Défis de Merlin",
        "file": "quest_ce_qui_est_petit_et_marron.mp3",
        "title": "Qu'est ce qui est petit et marron ? Un marron"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 47 - Le Complot",
        "file": "tropgentil.mp3",
        "title": "Vous savez ce que c'est mon problème ? Trop gentil !"
    },
    {
        "character": "Kadoc",
        "episode": "Livre V, 42 - Le Destitué",
        "file": "compote.mp3",
        "title": "Faut pas respirer de la compote, ça fait tousser"
    },
    {
        "character": "Kadoc",
        "episode": "Livre V, 33 - Domi Nostrae",
        "file": "casuffit.mp3",
        "title": "Ça suffit, ça suffit, ça suffit !!"
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 24 - Les Suppléants",
        "file": "incandescent.mp3",
        "title": "Incandescente, c'est : qui peut accaparer des objets sans ressurgir sur autrui"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 57 - Unagi II",
        "file": "inattendu.mp3",
        "title": "C'est systématiquement débile, mais c'est toujours inattendu !"
    },
    {
        "character": "Bohort",
        "episode": "Livre III, 03 - L'Aveu de Bohort",
        "file": "catastrophe.mp3",
        "title": "C'est une catastrophe !"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "malademental.mp3",
        "title": "Vous êtes un grand malade mental !"
    },
    {
        "character": "Yvain",
        "episode": "Livre V, 40 - Les Pionniers",
        "file": "ebaubir.mp3",
        "title": "Femme ! Cesse donc de nous ébaubir les oreilles ! Ohlala, il suffit !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre I, 01 - Heat",
        "file": "je_connais_que_le_cri.mp3",
        "title": "Ah non, moi j'connais que le cri. Piu piu piu papapapapapa"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 01 - Heat",
        "file": "moi_non_plus_je_vois_rien.mp3",
        "title": "Ah ben tourné vers là-bas c'est sûr, moi non plus je vois rien !"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 34 - Les Novices",
        "file": "on_est_pas_sorti_du_sable.mp3",
        "title": "Eh ben, on est pas sorti du sable !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 3 - La Table de Breccan",
        "file": "buffet_a_vaisselle.mp3",
        "title": "Encore une chance qu'on se soit pas fait construire un buffet à vaisselle, hein !"
    },
    {
        "character": "Fearmac",
        "episode": "Livre II, 09 - Le Terroriste",
        "file": "hein_titi.mp3",
        "title": "Hein Titi !"
    },
    {
        "character": "Fearmac",
        "episode": "Livre II, 09 - Le Terroriste",
        "file": "fumier.mp3",
        "title": "Fumier !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre IV, 25 - L’Échelle de Perceval",
        "file": "faisons_table_en_marbre.mp3",
        "title": "Du passé faisons table en marbre"
    },
    {
        "character": "Venec",
        "episode": "Livre II, 88 - Les Esclaves",
        "file": "ni_vu_ni_connu.mp3",
        "title": "Ni vu, ni connu"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "ca_me_fait_gerber.mp3",
        "title": "Ça me fait gerber"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "et_si_vous_arretiez_de_gueuler.mp3",
        "title": "Et si vous arrêtiez de gueuler, un peu ?"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "ya_pas_de_mal.mp3",
        "title": "Y'a pas d'mal"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 54 - The Game",
        "file": "ah_bah_alors_la_je_les_attends_les_mecs.mp3",
        "title": "Ah bah alors là, je les attends les mecs"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 54 - The Game",
        "file": "ah_oui_bravo_une_belle_lecon_de_sport.mp3",
        "title": "Ah oui bravo, une belle leçon de sport"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 54 - The Game",
        "file": "des_pedales_ils_disent_sur_le_message.mp3",
        "title": "Des pédales, ils disent, sur le message"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 54 - The Game",
        "file": "fagot_fagot_fagot.mp3",
        "title": "Fagot ! Fagot ! Fagot !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 54 - The Game",
        "file": "jsuis_a_mon_poste_cest_pas_le_cas_de_tout_le_monde.mp3",
        "title": "J'suis à mon poste ! C'est pas le cas de tout le monde !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 54 - The Game",
        "file": "nan_la_sans_deconner_cest_zero.mp3",
        "title": "Nan là sans déconner, c’est zéro"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 54 - The Game",
        "file": "vous_allez_pas_commencer_avec_vos_termes_pourris.mp3",
        "title": "Bah dîtes-le. Vous allez pas commencer avec vos termes pourris"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 54 - The Game",
        "file": "vous_etes_des_damnes.mp3",
        "title": "VOUS ÊTES DES DAMNÉS !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre I, 43 - La Coccinelle de Madenn",
        "file": "les_premieres_oeillades.mp3",
        "title": "Les premières œillades, la flûte enchantée, et trois mois après patatraque !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 43 - La Coccinelle de Madenn",
        "file": "mes_endives.mp3",
        "title": "L'autre jour on s'entraînait dans un champ à la catapulte, y'en a un qui arrive : \"oh mes endives mes endives\". On lui a mis un rocher sur la tête, ça l'a calmé l'bouseux."
    },
    {
        "character": "Séli",
        "episode": "Livre III, 52 - La cassette II",
        "file": "tout_dans_le_furtif.mp3",
        "title": "Pas un bruit, pas un mouvement, tout dans l'furtif. Vous avez glissé du pageot comme un pet sur une plaque de verglas !"
    },
    {
        "character": "Séli",
        "episode": "Livre III, 52 - La cassette II",
        "file": "arretez_immediatement_de_me_prendre_pour_une_truite.mp3",
        "title": "Arrêtez immédiatement de m'prendre pour une truite !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre III, 60 - Les festivités",
        "file": "gigoter_des_miches_ca_donne_faim.mp3",
        "title": "Surtout que gigoter des miches, ça donne faim…"
    },
    {
        "character": "Léodagan",
        "episode": "Livre III, 60 - Les festivités",
        "file": "on_essaie_de_catapulter_un_danseur.mp3",
        "title": "Ou alors on essaie d'catapulter un danseur"
    },
    {
        "character": "Karadoc",
        "episode": "Livre III, 67 - La Baraka",
        "file": "sans_blague_ya_pas_dla_gourdasse.mp3",
        "title": "Sans blague, y'a pas d'la gourdasse !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre III, 70 - La potion de fécondité II",
        "file": "ca_me_plait_qu_a_moitie.mp3",
        "title": "Euh… Si c'est d'moi qu'vous parlez, j'vous préviens que ça m'plaît qu'à moitié."
    },
    {
        "character": "Séli",
        "episode": "Livre III, 70 - La potion de fécondité II",
        "file": "une_claque_dans_le_museau_vous_repondez.mp3",
        "title": "Et à une claque dans l'museau, vous répondez ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre III, 70 - La potion de fécondité II",
        "file": "jy_vais_javoine.mp3",
        "title": "J'y vais ? J'avoine ?"
    },
    {
        "character": "Appius Manilius",
        "episode": "Livre VI, 07 - Arturus Rex",
        "file": "cest_bien_quon_reste_un_peu_dehors.mp3",
        "title": "Ouais c'est bien qu'on reste un peu dehors, comme ça j'pourrais vous mettre une grosse tarte en plein air"
    },
    {
        "character": "Séli",
        "episode": "Livre III, 72 - La restriction II",
        "file": "alors_le_ratichon_on_a_un_ptit_creux.mp3",
        "title": "Alors le ratichon, on a un p'tit creux ?"
    },
    {
        "character": "Karadoc",
        "episode": "Livre III, 72 - La restriction II",
        "file": "faites_gaffe_aux_pieges_a_loups.mp3",
        "title": "Faites gaffe aux pièges à loup j'en ai rajouté !"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre II, 19 - L'Absolution",
        "file": "au_bucher_demon_expie_tes_fautes.mp3",
        "title": "Au bûcher démon expie tes fautes !"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre II, 19 - L'Absolution",
        "file": "ne_te_mets_pas_en_dehors_du_chemin_de_la_redemption.mp3",
        "title": "Ne te mets pas en dehors du chemin de la rédemption, Satan !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 95 - Le Plat National",
        "file": "Comment_ca_on_bute_Karadoc.mp3",
        "title": "Comment ça, 'on bute Karadoc ?'"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 09 - La Faute (2ème Partie)",
        "file": "allez_vous_preparer_mousaillon_on_largue_les_amarres_dans_une_heure.mp3",
        "title": "Allez vous préparer mousaillon, on largue les amarres dans une heure !"
    },
    {
        "character": "Mévanoui",
        "episode": "Livre IV, 09 - La Faute (2ème Partie)",
        "file": "ecoutez_je_comprend_rien_a_ce_que_vous_faites.mp3",
        "title": "Écoutez, je comprends rien à ce que vous faites"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 09 - La Faute (2ème Partie)",
        "file": "est_ce_quil_sait_nager_deja.mp3",
        "title": "Est-ce qu'il sait nager, déjà ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 09 - La Faute (2ème Partie)",
        "file": "voila_passez_moi_la_canne_a_peche.mp3",
        "title": "Voilà, passez moi la… canne à pêche."
    },
    {
        "character": "Perceval",
        "episode": "Livre IV, 48 - Les Tacticiens (2ème Partie)",
        "file": "mais_moi_je_vous_previens_jy_connais_rien_en_champignon.mp3",
        "title": "Mais moi je vous préviens, j'y connais rien en champignon !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre IV, 48 - Les Tacticiens (2ème Partie)",
        "file": "ca_va_si_faut_sonner_lalerte_vous_pouvez_bien_attendre_que_je_revienne_nan.mp3",
        "title": "Ça va, si faut sonner l'alerte, vous pouvez bien attendre que je revienne, nan ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre IV, 48 - Les Tacticiens (2ème Partie)",
        "file": "oui_et_ben_moi_je_vous_donne_lordre_de_lui_preter_votre_corne_parce_que_quand_on_est_gentil_on_prete.mp3",
        "title": "Oui, et ben moi je vous donne l'ordre de lui prêter votre corne, parce que quand on est gentil, on prête !"
    },
    {
        "character": "Perceval",
        "episode": "Livre IV, 48 - Les Tacticiens (2ème Partie)",
        "file": "ca_vous_regarde_pas_cest_secret_ok.mp3",
        "title": "Ça vous regarde pas, c'est secret, ok ?"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison Et Sentiments",
        "file": "ah__enfin_vous_voila_mon_ami__mais_que_se_passe_t_il_jentends_crier.mp3",
        "title": "Ah ! Enfin vous voilà mon ami ! Mais que se passe-t-il, j'entends crier ?"
    },
    {
        "character": "Yvain",
        "episode": "Livre IV, 49 - Drakkars !",
        "file": "ouais_cest_mortel_ouais.mp3",
        "title": "Ouais, c'est mortel, ouais"
    },
    {
        "character": "Léodagan",
        "episode": "Livre IV, 49 - Drakkars !",
        "file": "ya_pas_un_pigeon_pour_envoyer_un_message.mp3",
        "title": "Ya pas UN pigeon pour envoyer un message ?"
    },
    {
        "character": "Bohort",
        "episode": "Livre IV, 49 - Drakkars !",
        "file": "cest_une_catastrophe_souffle.mp3",
        "title": "C'est une catastrophe… (soufflé)"
    },
    {
        "character": "Yvain",
        "episode": "Livre II, 86 - Les Félicitations",
        "file": "ben_oui_cest_une_rime_triple__blanche_et_seche_poitrine_et_prairie_de_notre_enfance.mp3",
        "title": "Ben oui, c'est une rime triple ! Blanche et sèche, poitrine et praiRIE, de notre enfance !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 86 - Les Félicitations",
        "file": "alors_moi_jai_un_petit_probleme__jai_pas_pige_un_broc_de_ce_que_vous_bavez.mp3",
        "title": "Alors, moi j'ai un petit problème : c'est que j'ai pas pigé UN BROC de ce que vous bavez."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 10 - La Chambre",
        "file": "vous_avez_pas_limpression_que_je_suis_dans_une_baignoire.mp3",
        "title": "Vous avez pas l'impression que je suis dans une baignoire ?"
    },
    {
        "character": "Venec",
        "episode": "Livre III, 95 - Le Professionnel",
        "file": "Ren_dez_vous_a_la_ta_verne_incognito.mp3",
        "title": "Ren...dez...vous... ce soir... à la ta-verne ! Et incognito !"
    },
    {
        "character": "Loth",
        "episode": "Livre VI, 06 - Nuptiae",
        "file": "on_fera_tintin_pour_le_clafoutis.mp3",
        "title": "Oui. Alors moi je pourrais vous dire que... Si on cueille pas les cerises quand elles sont sur l'arbre, on fera tintin pour le clafoutis. Mais on sera pas plus avancés."
    },
    {
        "character": "Loth",
        "episode": "Livre III, 27 - L’Assemblée des Rois",
        "file": "tempora_mori.mp3",
        "title": "Tempora mori, tempora mundis recorda. Voilà, eh ben ça par exemple, ça ne veut absolument rien dire, mais l’effet reste le même..."
    },
    {
        "character": "Loth",
        "episode": "Livre IV, 49 - Le désordre et la nuit",
        "file": "victoriae_mundis.mp3",
        "title": "Victoriae mundis et mundis lacrima. Bon, ça ne veut absolument rien dire, mais je trouve que c’est assez dans le ton."
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 11 - Dîner dansant",
        "file": "oh_putain_oui.mp3",
        "title": "Oh putain oui !"
    },
    {
        "character": "Yvain",
        "episode": "Livre I, 50 - Les Nouveaux Frères",
        "file": "ce-serait-hyper.mp3",
        "title": "Ce serait hyper whoooo"
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre I, 14 - Monogame",
        "file": "les-femmes-jaime-pas-ca-c'est-de-la-saloperie.mp3",
        "title": "Tu sais moi pour moi les femmes j'aime pas ça c'est de la saloperie"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "a_mon_epoque_ca_se_faisait_pas.mp3",
        "title": "Moi à mon époque, ça se faisait pas"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "ca_me_ferait_mal.mp3",
        "title": "Ah bah ça m'ferait mal"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "cest_beau_quand_meme.mp3",
        "title": "C'est beau quand même"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "chevalierisation.mp3",
        "title": "Ils auraient pu se creuser la tronche pour trouver un autre nom. Je sais pas moi... Chevalierisation. Quoi, déjà pris?"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "on_a_pas_regarde_dans_les_f.mp3",
        "title": "Bah j'sais pas, on a pas regardé dans les F, si ?"
    },
    {
        "character": "Hervé De Rinel",
        "episode": "Livre III, 91 - L'Espion",
        "file": "de_quoi_desole_excusez_moi_j_ecoutais_pas.mp3",
        "title": "De quoi... Désolé... Excusez-moi... J'écoutais pas !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre III, 91 - L'Espion",
        "file": "et_puis_y_a_toujours_une_proportion_de_secoues.mp3",
        "title": "Et puis y'a toujours une proportion de secoués dans tous les métiers de toute façon hein"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre III, 91 - L'Espion",
        "file": "lui_on_comprend_ni_ce_qu_il_dit_ni_ce_qu_il_fait.mp3",
        "title": "Lui, on comprend ni ce qu'il dit, ni ce qu'il fait... C'est rare !"
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 91 - L'Espion",
        "file": "allez_vous_reposer_vous_l_avez_bien_merite.mp3",
        "title": "Allez vous reposer, vous l'avez bien mérité"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison et Sentiments",
        "file": "je_veux_mhabiller_de_lierre_et_me_coiffer_de_roseaux.mp3",
        "title": "Je veux m'habiller de lierre, et me coiffer de roseaux !"
    },
    {
        "character": "Lancelot",
        "episode": "Livre IV, 03 - Raison et Sentiments",
        "file": "vous_allez_me_lacher_les_noyaux_oui.mp3",
        "title": "Vous allez me lâcher les noyaux, oui ?!"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison et Sentiments",
        "file": "petit_a_petit_vers_plus_dautonomie.mp3",
        "title": "Je crois qu'il faut se diriger petit à petit vers plus d'autonomie, plus de responsabilités."
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison et Sentiments",
        "file": "vous_comprenez_le_principe.mp3",
        "title": "Vous comprenez le principe ?"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison Et Sentiments",
        "file": "oui.mp3",
        "title": "Oui ?"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre IV, 03 - Raison et Sentiments",
        "file": "excusez_moi_hein_je_ne_connais_pas_encore_bien_vos_noms.mp3",
        "title": "Excusez-moi, hein, je ne connais pas encore bien vos noms !"
    },
    {
        "character": "Kadoc",
        "episode": "Livre IV, 70 - Le Paladin",
        "file": "dans_trois_jours_cest_les_vacances.mp3",
        "title": "Dans trois jours c'est les vacances."
    },
    {
        "character": "Kadoc",
        "episode": "Livre IV, 70 - Le Paladin",
        "file": "dans_trois_jours_ma_tata_elle_menmene_a_la_mer_pour_me_noyer.mp3",
        "title": "Dans trois jours ma tata elle m'enmène à la mer pour me noyer."
    },
    {
        "character": "Le Répurgateur",
        "episode": "Livre IV, 70 - Le Paladin",
        "file": "je_vais_devenir_paladin.mp3",
        "title": "Je vais devenir... Paladin !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre IV, 70 - Le Paladin",
        "file": "sire_vous_me_flattez.mp3",
        "title": "Sire, vous me flattez…"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre IV, 63 - Le Jeu de la guerre",
        "file": "j_apprecie_les_fruits_au_sirop.mp3",
        "title": "J'apprécie les fruits au sirop !"
    },
    {
        "character": "Yvain",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "vous_laissez_pas_embobiner_ils_cherchent_a_vous_rembobiner.mp3",
        "title": "Vous laissez pas embobiner... Ils cherchent à vous rembobiner !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "il_pige_rien_a_rien.mp3",
        "title": "Il pige rien à rien !"
    },
    {
        "character": "Yvain",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "c_est_pas_parce_qu_ils_ont_trahi_que_c_est_plus_des_allies.mp3",
        "title": "C'est pas parce qu'ils ont trahi que c'est plus des alliés"
    },
    {
        "character": "Gauvain",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "simple_deduction_mon_oncle.mp3",
        "title": "Simple déduction mon oncle"
    },
    {
        "character": "Yvain",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "embobinage_dans_l_air.mp3",
        "title": "Embobinage dans l'air..."
    },
    {
        "character": "Yvain",
        "episode": "Livre IV, 78 - Le Choix de Gauvain",
        "file": "ah_ouais_vous_seriez_une_sorte_de_bi_taupe_en_fait.mp3",
        "title": "Ah ouais ! Vous seriez une sorte de bi-taupe en fait !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "alors__a_qui_cest_quelle_est_morte_la_va_vache.mp3",
        "title": "Alors ? À qui c'est qu'elle est morte, la va-vache ?"
    },
    {
        "character": "Séli",
        "episode": "Livre I, 02 - La Tarte aux Myrtilles",
        "file": "quest_ce_que_vous_attendez_pour_la_couper.mp3",
        "title": "Eh ben, qu'est-ce que vous attendez pour la couper ? Qu'il fasse nuit ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 02 - La Tarte aux Myrtilles",
        "file": "oui_ou_une_fissure_a_colmater_dans_un_muret.mp3",
        "title": "Oui… Ou une fissure à colmater dans un muret !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 02 - La Tarte aux Myrtilles",
        "file": "bon_bah_ca_va_on_plaisante.mp3",
        "title": "Bon bah ça va, on plaisante !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 12 - Le Sixième Sens",
        "file": "au_bout_dun_moment_on_a_prefere_plus_rien_dire.mp3",
        "title": "Ah bah nous au bout d'un moment on a préféré plus rien dire !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 91 - La Fureur du Dragon",
        "file": "sils_sont_equidistants_on_peut_reperer_le_dragon.mp3",
        "title": "S'ils sont équidistants en même temps que nous, on peut repérer le dragon par rapport à une certaine distance"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "kaamelott_cest_pas_une_cooperative_bovine.mp3",
        "title": "Nan mais Kaamelott c'est pas une coopérative bovine ! On a pas de vaches !"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "elle_avait_rien_a_y_foutre_deja_pour_commencer.mp3",
        "title": "Elle avait rien à y foutre déjà pour commencer"
    },
    {
        "character": "Roparzh",
        "episode": "Livre II, 69 - Feue La Vache De Roparzh",
        "file": "elle_avait_choppe_toutes_les_maladies.mp3",
        "title": "Et puis quand elle est revenue, elle avait choppé toutes les maladies qu'existent"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 12 - Le Sixième Sens",
        "file": "jai_rien_compris.mp3",
        "title": "J'ai rien compris !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "vous_balader_avec_une_cuillere_a_soupe_ca_changerait_rien.mp3",
        "title": "Nan mais on s'en fout, c'est pas une question d'armure ou d'épée, vous pourriez vous balader avec une cuillère à soupe ça changerait rien ! L'adoubement c'est une CONDITION pour être chevalier !"
    },
    {
        "character": "Perceval",
        "episode": "Livre I, 40 - L'Adoubement",
        "file": "vous_cassez_pas_la_nenette_pour_moi.mp3",
        "title": "C'est gentil, mais ne vous cassez pas la nénette pour moi !"
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "quand_je_comprends_pas_je_reponds_pas.mp3",
        "title": "Non, quand je comprends pas, je réponds pas."
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "essayez_de_faire_des_phrases_pour_vous_deja.mp3",
        "title": "Essayez de faire des phrases pour vous déjà, on verra après le reste."
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "cest_chaud_quand_meme.mp3",
        "title": "C'est chaud quand même."
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "ah_bah_ouais_mais_apres_il_faut_un_peu_de_technique.mp3",
        "title": "Ah bah ouais mais après il faut un peu de technique."
    },
    {
        "character": "Arthur",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "cest_toujours_un_peu_delicat_de_parler_damour_aux_cons.mp3",
        "title": "Bah c'est toujours un peu délicat de parler d'amour aux cons."
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 81 - Le Vulgarisateur",
        "file": "heu_cest_plutot_des_cons.mp3",
        "title": "Heu... C'est plutôt des cons."
    },
    {
        "character": "Attila",
        "episode": "Livre III, 17 - Le Fléau de Dieu II",
        "file": "elle_vomit.mp3",
        "title": "Elle vomit ?"
    },
	{
        "character": "Urgan",
        "episode": "Livre III, 23 - Le professionnel",
        "file": "sire-je-ne-suis-pas-homme.mp3",
        "title": "Sire, sachez déjà que je ne suis pas homme à me méprendre sur le gaillard d'en face. Mon petit doigt me dit que vous n'en êtes pas la moitié d'un."
    },
	{
        "character": "Urgan",
        "episode": "Livre III, 23 - Le professionnel",
        "file": "urgan-lhomme-goujon.mp3",
        "title": "Je suis Urgan, dit l'homme goujon, chevalier des mers au service de votre seigneurie."
    },
	{
        "character": "Urgan",
        "episode": "Livre III, 23 - Le professionnel",
        "file": "Tout-travail-merite-salaire.mp3",
        "title": "Au même titre que le bar est fermé, sauf si c'est un poisson, tout travail mérite salaire."
    },
	{
        "character": "Urgan",
        "episode": "Livre III, 23 - Le professionnel",
        "file": "Homme-sans-metier.mp3",
        "title": "Homme sans métier n'est plus apte à exercer une activité professionnelle"
    },
	{
        "character": "Arthur",
        "episode": "Livre III, 23 - Le professionnel",
        "file": "A-titre-purement-informatif.mp3",
        "title": "Mais, à titre purement informatif, vous prendriez combien ?"
    },
	{
        "character": "Léodagan",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "Soyez-souple-un-peu.mp3",
        "title": "Soyez souple un peu"
    },
    {
        "character": "Gauvain",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "Les-petits-pedestres.mp3",
        "title": "Nous sommes jeunes, nous marchons à pieds... J’opterai donc pour un surnom en rapport : \"les Petits Pédestres\"."
    },
	{
        "character": "Yvain",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "Les-petits-pedestres-dont-un-au-lion.mp3",
        "title": "On pourrait pas plutôt dire : \"Les Petits Pédestres dont un au lion ?\""
    },
	{
        "character": "Séli",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "ils-se-sont-pas-leve-1.mp3",
        "title": "Ils se sont pas levés 1"
    },
	{
        "character": "Séli",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "ils-se-sont-pas-leve-2.mp3",
        "title": "Ils se sont pas levés 2"
    },
	{
        "character": "Séli",
        "episode": "Livre IV, 39 - Le Grand Départ",
        "file": "ils-se-sont-pas-leve-3.mp3",
        "title": "Ils se sont pas levés 3"
    },
    {
        "character": "Le Roi Burgonde",
        "episode": "Livre II, 44 - Le Dialogue de Paix",
        "file": "oh_ca_fait_rien.mp3",
        "title": "Oh ça fait rien"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 12 - La Délégation Maure",
        "file": "fer-a-cheval.mp3",
        "title": "Si vous dites fer à cheval, je vous colle aux travaux forcés pendant 6 mois."
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 16 - Les Fruits d’hiver",
        "file": "bibelots-mongol-parthenon.mp3",
        "title": "Ça fait une heure que vous admirez des bibelots en souriant comme un mongol ; vous êtes dans la salle à manger du roi pour un déjeuner protocolaire, vous visitez pas le parthénon !"
    },
    {
        "character": "Arthur",
        "episode": "Livre V, 16 - Les Fruits d’hiver",
        "file": "gerber-mourir.mp3",
        "title": "Non, la seule chose que vous risquez c'est de gerber et éventuellement de mourir."
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 16 - Les Fruits d’hiver",
        "file": "quicher-tete.mp3",
        "title": "Je viens de me faire quicher la tête et il me semble que vous étiez là, ça vous inspire là ou il y a rien qui vient ?"
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 16 - Les Fruits d’hiver",
        "file": "tape-la-honte.mp3",
        "title": "Alors là je cherche... mais je me souviens pas m'être autant tapé la honte comme ça."
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "blaireau-peignecul-tarlouze.mp3",
        "title": "C'est-à-dire que là nous sommes avec une personne qui ne va pas hésiter si vous voulez à... à aller piocher dans un lexique très intuitif, donc on va être sur du blaireau, sur du peigne-cul heu... sur de la tarlouze. Voilà c'est pour ça que je vous demande, heu, qu'est-ce que vous dites vous à votre épouse pour désamorcer, quoi, le conflit."
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "bled-natal-fion.mp3",
        "title": "Et à partir de maintenant si j'entends un mot plus haut que l'autre je vous renvoie dans votre bled d'att... natal à coup de pied dans... dans le fion."
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "fiotte-tatie.mp3",
        "title": "Non mais je crois que c'est plus simple que ça : vous êtes une fiotte. J'ai épousé une grosse tatie voilà... mais quand on le formule ça pose pas de problème en fait."
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "pires-trucs-reparation.mp3",
        "title": "Si on lui met là une chaise dans le coin là bas... ou non mieux, ici, on l'asseoit là, pendant qu'on fait les pires trucs, il demandera pas réparation. C'est un style, voyez ?"
    },
    {
        "character": "La Duchesse d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "plus-trop-parler.mp3",
        "title": "Ce que vous allez faire c'est que vous allez plus trop parler vers ici."
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "ratisser-bouse-torcher-cul-poules.mp3",
        "title": "Comme ça vous pourrez aller ratisser la bouse et torcher le cul des poules ça vous fera prendre l'air."
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 19 - Les Nocturnales",
        "file": "tete-roupiller-couloir.mp3",
        "title": "Si c'est ma tête qui vous revient pas vous pouvez toujours aller roupiller dans le couloir !"
    },
    {
        "character": "Arthur",
        "episode": "Livre V, 23 - Le Forfait",
        "file": "bateau-nage.mp3",
        "title": "Vous lui dites : OK, d'accord heu... vous partez quand vous voulez. Et dans un second temps, quand elle se demande ce qu'il se passe, vous enchaînez : seulement comme c'est moi qui prend le bateau vous rentrez à la nage."
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 23 - Le Forfait",
        "file": "degaine-crevette-merou.mp3",
        "title": "Avec votre dégaine de crevette faites gaffe à pas vous faire bouffer par un mérou !"
    },
    {
        "character": "Le Duc d'Aquitaine",
        "episode": "Livre V, 23 - Le Forfait",
        "file": "demain-cest-demain.mp3",
        "title": "Demain c'est demain, si j'ai besoin de votre avis je vous le demande."
    },
    {
        "character": "Arthur",
        "episode": "Livre V, 23 - Le Forfait",
        "file": "gras-sur-le-cul.mp3",
        "title": "Comme ça, ça vous fera perdre un peu le gras que vous avez sur le cul !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 86 - Les Félicitations",
        "file": "cest_lanniversaire_dans_tous_les_recoins.mp3",
        "title": "C'est l'anniversaire dans tous les recoins, c'est presque tous les ans qu'on a l'anniversaire, grâce à cet anni, c'est la joie, c'est pratique, c'est au moins un principe à retenir pour faire la frite, lalala, cette année c'est bien l'anniversaire tombe à pic !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 97 - La Conscience d'Arthur",
        "file": "vous_etes_un_gros_nul.mp3",
        "title": "Vous êtes un gros nul, d'accord ? Un vrai gros naze"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "allez-quoi-on-a-besoin-dune-potion.mp3",
        "title": "Allez quoi ! On a besoin d'une potion, on va pas la faire nous-même si ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 01 - Spangenhelm",
        "file": "il-n-y-a-rien-a-prier.mp3",
        "title": "Il n'y a rien à prier on se souvient pas des mecs de toute façon"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 01 - Spangenhelm",
        "file": "bon-de-toute-facon.mp3",
        "title": "Bon de toute façon on vous demande de prier, vous priez, vous discutaillez pas des plombes du pourquoi du comment ! Commence à me gonfler léger ça aussi !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "mais-compare-a-ce-quon-a-trouve.mp3",
        "title": "Mais comparé à ce qu'on a trouvé, la potion de puissance ça vaut de la pisse"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 50 - Always",
        "file": "mais-vous-etes-pas-mort-espece-de-connard.mp3",
        "title": "Mais vous êtes pas mort espèce de connard ?!"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 50 - Always",
        "file": "le-seigneur-perceval-ne-se-met-jamais-en-situation-dangeureuse.mp3",
        "title": "Le seigneur Perceval ne se met jamais en situation dangeureuse. Pour ça il fait preuve d'une intelligence redoutable"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 46 - Le Cadeau",
        "file": "la-chevre-a-beler-5-min.mp3",
        "title": "La chèvre elle a bêlé 5 minutes. Vous, vous râlez depuis 3h. Pensez-y"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 45 - Amen",
        "file": "tu-ne-tuera-point.mp3",
        "title": "Tu ne tueras point, comment on fait nous derrière ? Non c’est comme ça. C’est, voilà, c’est un peu, tu ne tueras point, voilà. Bon allez on y va."
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 45 - Amen",
        "file": "on-pisse-pas-contre-les-murs-de-la-chapelle-cest-clair.mp3",
        "title": "ON PISSE PAS CONTRE LES MURS DE LA CHAPELLE C'EST CLAIR !"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 44 - L’Invincible",
        "file": "notre-enchanteur-minforme-que-dhabitude-il-y-arrive-tres-bien.mp3",
        "title": "Notre enchanteur m'informe que d'habitude il y arrive très bien mais que là, visiblement, ça marche pas !"
    },
    {
        "character": "Merlin",
        "episode": "Livre II, 44 - L’Invincible",
        "file": "remarquez-jai-un-pote-poissonier.mp3",
        "title": "Remarquez j'ai un pote poissonier qui sait boire du lait à la paille par les trous de nez"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 43 - La Voix Céleste",
        "file": "et-bah-tu-peux-te-la-garder.mp3",
        "title": "Et bah tu peux te la garder !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 43 - La Voix Céleste",
        "file": "ah-non-vous-allez-pas-bouder.mp3",
        "title": "Ah non vous allez pas bouder ?!"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 43 - La Voix Céleste",
        "file": "merde-la-ca-vous-va-ca.mp3",
        "title": "Merde, là ! Ça vous va ça ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 43 - La Voix Céleste",
        "file": "mais-vous-guidez-que-dalle.mp3",
        "title": "Mais vous guidez que dalle alors, vous êtes encore plus paumée que moi, venez pas me la jouer !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 42 - La Fête du Printemps",
        "file": "mais-cest-incroyable-jai-limpression-de-bouffer-de-la-terre.mp3",
        "title": "Non mais c’est incroyable. J’ai l’impression de bouffer de la terre avec de la bouse et du gravier, ça sent le poulailler, mais c’est du céleri et des oignons, c’est prodigieux."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 42 - La Fête du Printemps",
        "file": "le-plus-interessant-cest-comment-vous-arrivez-a-faire-un-truc-aussi-immonde.mp3",
        "title": "Le plus intéressant c’est : comment est-ce que vous arrivez à faire un truc aussi immonde avec des ingrédients normaux ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 42 - La Fête du Printemps",
        "file": "vous-me-dites-il-faut-quelque-chose-de-festif.mp3",
        "title": "Vous me dites il faut quelque chose de festif"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 41 - O'Brother",
        "file": "pas-moyen-de-piger-un-broc-de-ce-quil-dit.mp3",
        "title": "Pas moyen de piger un broc de ce qu'il dit"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "comme-la-mare-aux-canards.mp3",
        "title": "Comme la mare aux canards ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 41 - O'Brother",
        "file": "quoi-bah-mon-cochon-vous-manquez-pas-de-cran.mp3",
        "title": "Quoi ? Bah mon cochon vous manquez pas de cran !"
    },
    {
        "character": "Kadoc",
        "episode": "Livre II, 41 - O'Brother",
        "file": "jai-le-droit-detre-4-jours-pas-chez-moi.mp3",
        "title": "J’ai le droit d’être 4 jours pas chez moi... et après chez moi. Mais y a du voyage qui se prépare et euh, pour soigner les bêtes, y a pas que ma tante, y a moi aussi"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 41 - O'Brother",
        "file": "karadoc-cest-le-gars-brillant.mp3",
        "title": "Bah, Karadoc c’est le gars brillant, quoi... le frère à côté c’est sûr, euh... c’est vraiment un gros con"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 40 - Les Pigeons",
        "file": "vous-pouvez-aller-vous-gratter.mp3",
        "title": "Vous pouvez aller vous gratter. C'est signé... ah non mais c'est moi ça !"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 39 - La Rencontre",
        "file": "alors-oisif-obese-autant-dire-des-gros-cons.mp3",
        "title": "Alors oisif, obèse, autant dire des gros cons"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 39 - La Rencontre",
        "file": "la-cest-sur-vu-les-tronche-que-vous-tirez.mp3",
        "title": "Là c'est sûr que vu les tronches que vous tirez ça file pas tellement envie de faire la fiesta"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 39 - La Rencontre",
        "file": "oh-non-mais-il-y-a-des-jours-vous-deconnez-sec.mp3",
        "title": "Oh non mais il y a vraiment des jours où vous déconnez sec"
    },
    {
        "character": "Ygerne de Tintagel",
        "episode": "Livre II, 39 - La Rencontre",
        "file": "evitez-de-mappeler-maman.mp3",
        "title": "Évitez de m'appeler maman !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 38 - Le Larcin",
        "file": "cest-de-la-daube.mp3",
        "title": "C'est plutôt du... c'est du... c'est, c'est de la daube quoi"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 38 - Le Larcin",
        "file": "quoi-mais-cest-un-scandale.mp3",
        "title": "Quoi ?! Mais c'est un scandale !"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre II, 37 - L’Escorte II",
        "file": "vous-me-prenez-vraiment-pour-une-conne.mp3",
        "title": "Vous me prenez vraiment pour une conne"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre II, 37 - L’Escorte II",
        "file": "quest-ce-que-cest-ce-nouveau-genre-seigneur-lancelot.mp3",
        "title": "Qu'est ce que c'est ce nouveau genre seigneur Lancelot, vous oubliez peut-être que vous parlez à des GROSSES BOURGES !"
    },
    {
        "character": "Le tavernier",
        "episode": "Livre II, 37 - L’Escorte II",
        "file": "entre-le-roi-arthur-quest-pas-capable-de-denicher-son-graal.mp3",
        "title": "Entre le roi Arthur qu'est pas capable de dénicher son Graal et la reine qu'est con comme une chaise !"
    },
    {
        "character": "Le tavernier",
        "episode": "Livre II, 37 - L’Escorte II",
        "file": "la-vue-du-bourgeois-ca-me-fait-de-laerophagie.mp3",
        "title": "J'sais pas si c'est d'naissance ou quoi mais moi, la vue du bourgeois, ça m'fait d'l'aérophagie."
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "la-tournure-est-plus-graduelle.mp3",
        "title": "La tournure est plus graduelle"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "non-mais-franchement-je-serais-nous-je-vous-ecouterais.mp3",
        "title": "Ah mais moi franchement, je serais nous. Non. Je serais vous, j’vous écouterais."
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "maintenant-il-faut-nous-ecouter-parce-que-la-on-en-a-gros.mp3",
        "title": "Maintenant il faut nous écouter ! Parce que là on en a gros"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "moi-je-serais-vous-je-vous-ecouterais.mp3",
        "title": "Moi, j'serais vous, je vous écouterais"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 36 - Les Exploités",
        "file": "faites-pas-le-con-sire-ouvrez.mp3",
        "title": "Faites pas le con sire, ouvrez !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 35 - Merlin l'Archaïque",
        "file": "bah-alors-884-charrettes-de-bouses.mp3",
        "title": "Bah alors 884 charrettes de bouse"
    },
    {
        "character": "Guenièvre",
        "episode": "Livre II, 35 - Merlin l'Archaïque",
        "file": "je-moccupe-de-tout-dite-oui.mp3",
        "title": "Allez, je m'occupe de tout. Dites oui ! Dites oui ! Dites oui !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 35 - Merlin l'Archaïque",
        "file": "rien-ca-fait-rien-cassez-vous.mp3",
        "title": "Rien, ça fait rien, cassez-vous"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 35 - Merlin l'Archaïque",
        "file": "cest-pas-du-tout-mon-anniversaire.mp3",
        "title": "C'est pas du tout mon anniversaire"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 34 - La Ronde",
        "file": "est-ce-que-vous-allez-finir-par-fermer-vos-gueules.mp3",
        "title": "Est-ce que vous allez finir par fermer vos gueules ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 34 - La Ronde",
        "file": "qu-est-ce-que-cest-cette-tisane.mp3",
        "title": "Qu'est-ce que c'est qu'cette tisane ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 34 - La Ronde",
        "file": "pourquoi-voulez-vous-que-je-pense-a-la-reine.mp3",
        "title": "À la reine ? Pourquoi voulez-vous que je pense à la reine ? Je suis déjà à moitié crevé, j'ai assez de soucis comme ça"
    },
    {
        "character": "Belt",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "nous-on-foule-le-fruit-avec-nos-propres-pieds.mp3",
        "title": "Nous on foule le fruit avec nos propres pieds"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "le-votre-aussi-cest-de-la-merde.mp3",
        "title": "Le vôtre aussi c'est de la merde"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "cest-de-la-merde.mp3",
        "title": "C'est de la merde 2"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "cest-de-la-merde-merci-messieurs.mp3",
        "title": "Eh ben ? Eh ben voilà ! C’est bien pour la peine de rester huit jours. C’est alors donc : y en a pas un pour racheter l’autre, c’est d’la merde, merci messieurs."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "non-il-est-degueulasse-celui-la.mp3",
        "title": "Non, il est dégueulasse celui là"
    },
    {
        "character": "Belt",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "mais-cest-de-la-merde.mp3",
        "title": "Mais c’est d’l… d’la merde ! Enfin euh… Sire, est-ce qu’on est obligés de perdre du temps avec tous les pignoufs d’la région qui s’prennent pour des exploitants ?"
    },
    {
        "character": "Guethenoc",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "nan-mais-quand-meme.mp3",
        "title": "Nan mais quand même, non quand même, on vient pour essayer montrer quelque chose de sérieux, vous arrivez avec du jus de pieds, faut pas exagérer non plus"
    },
    {
        "character": "Belt",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "vous-avez-pas-pris-le-temps-de-vous-habituer-au-fruit.mp3",
        "title": "Vous avez pas pris le temps de vous habituer au fruit"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 33 - Spiritueux",
        "file": "cest-une-blague.mp3",
        "title": "C'est une blague ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 31 - L’Ivresse",
        "file": "et-ca-cest-du-nougat.mp3",
        "title": "Et ça c'est du nougat !?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 31 - L’Ivresse",
        "file": "les-chevaliers-de-mes-deux.mp3",
        "title": "Les chevaliers de mes deux !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 31 - L’Ivresse",
        "file": "en-fait-jetais-dans-un-paturage.mp3",
        "title": "En fait, j'étais dans un pâturage, j'ai tué 76 chèvres"
    },
    {
        "character": "Lancelot",
        "episode": "Livre II, 30 - La Garde Royale",
        "file": "mais-qu-est-ce-que-vous-voulez-quon-en-foute-de-vos-peigne-culs.mp3",
        "title": "Mais qu'est-ce que vous voulez qu'on en foute de vos peigne-culs ?"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 30 - La Garde Royale",
        "file": "donc-vous-allez-faire-une-troupe-delite-avec-vos-cousins-debiles.mp3",
        "title": "Donc vous allez faire une troupe d'élite avec vos cousins débiles ?"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 30 - La Garde Royale",
        "file": "nan-mais-par-contre-ils-sont-super-cons.mp3",
        "title": "Nan mais par contre, ils sont super cons !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 29 - Les Mauvaises Graines",
        "file": "ils-commencent-par-apprendre-a-lire.mp3",
        "title": "Ils commencent par apprendre à lire, comme ils savent pas s'arrêter crac, ils apprennent à écrire, et voilà"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 29 - Les Mauvaises Graines",
        "file": "insoupconnable.mp3",
        "title": "Insoupçonnable !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 28 - Le Passage Secret",
        "file": "non-on-a-fait-3-bornes-sil-vous-plait.mp3",
        "title": "Non, on a fait 3 bornes. S'il vous plait, venez pas me parler de bout du monde"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 28 - Le Passage Secret",
        "file": "vous-savez-cest-pas-parce-quun-vieux-moisi.mp3",
        "title": "Vous savez c'est pas parce qu'un vieux moisi vient vous baver dans les étagère que ça vaut forcément quelque chose !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 27 - L’Ancien Temps",
        "file": "enfin-quand-cest-demande-gentiment.mp3",
        "title": "Enfin, quand c'est demandé gentiment"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 27 - L’Ancien Temps",
        "file": "bon-alors-combien-il-faut-que-casque-pour-la-fete-aux-pecores.mp3",
        "title": "Bon alors ? Combien il faut que je casque pour la fête aux pécores ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 27 - L’Ancien Temps",
        "file": "mais-non-qu-est-ce-que-jen-ai-a-carrer.mp3",
        "title": "Mais non, qu'est-ce que j'en ai à carrer"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 27 - L’Ancien Temps",
        "file": "ah-ouais-vous-madressez-carrement-plus-la-parole-en-fait.mp3",
        "title": "Ah ouais ! Vous m'adressez carrément plus la parole en fait ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 27 - L’Ancien Temps",
        "file": "elle-me-fixe-avec-ses-yeux-de-serpent.mp3",
        "title": "Elle me fixe aves ses yeux de serpent là"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "cest-marrant-les-petits-bouts-de-fromage-par-terre.mp3",
        "title": "C'est marrant les petits bouts de fromage par terre, c'est ça que vous appelez une fondue ?"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "non-mais-vous-pouvez-la-distraire-avec-un-numero-de-jonglage.mp3",
        "title": "Non mais vous pouvez la distraire avec un numéro de jonglage vous la toucherez pas avec ça !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "non-mais-biensur-donc-vous-vous-degommez-les-souris-au-maillet.mp3",
        "title": "Non mais biensûr. Donc vous, vous dégommez les souris au maillet ?"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 25 - Séli et les Rongeurs",
        "file": "et-celle-la-jirai-pas-me-coucher-avant-de-lavoir-bousillee.mp3",
        "title": "Et celle-là j'irai pas me coucher avant de l'avoir BOU-SI-LLÉE"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous les Verrous",
        "file": "mais-pas-du-tout.mp3",
        "title": "Mais pas du tout !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous les Verrous",
        "file": "mais-je-le-sais-bien-que-vous-avez-pas-les-cles-andouille.mp3",
        "title": "Mais je le sais bien que vous avez pas les clés ANDOUILLES ! Allez me chercher le geôlier"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous les Verrous",
        "file": "venez-mouvriiir.mp3",
        "title": "Venez m'ouvrir !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous les Verrous",
        "file": "allez-bon-dieu-mais-magnez-vous-ca-pue-la-dedans.mp3",
        "title": "Allez bon Dieu mais magnez-vous ça pue là dedans !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 24 - Sous les Verrous",
        "file": "parce-que-vous-etes-en-train-de-faire-une-connerie-la-quand-meme.mp3",
        "title": "Parce que vous êtes en train de faire une connerie là quand même, moi je serais vous j'y penserais"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 22 - Plus Près de Toi",
        "file": "merciiiii.mp3",
        "title": "Merciiiii !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 21 - La Cassette",
        "file": "ah-bah-cest-sur-on-se-marre.mp3",
        "title": "Ah bah c'est sûr on se marre"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 20 - Les Misanthropes",
        "file": "nan-nan-nous-on-est-pas-fixe.mp3",
        "title": "Ah non, mais nous, on n’est pas fixé ! On propose ça, c’qui compte c’est que ce soit un peu marrant, quoi ! Et pis pour vous, ça va vous faire rigoler un peu ! C’est pas bon d’rester enfermé dans votre cagibi à glander toute la journée"
    },
    {
        "character": "Merlin",
        "episode": "Livre II, 20 - Les Misanthropes",
        "file": "franchement-une-potion-pour-faire-pisser-bleu.mp3",
        "title": "Franchement, une potion pour faire pisser bleu ça pressait à la minute là ?"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 20 - Les Misanthropes",
        "file": "il-n-y-a-pas-dequivoque-vous-etes-franchement-un-bourrin.mp3",
        "title": "Il n'y a pas d'équivoque, vous êtes franchement un bourrin en toute circonstance"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 19 - L'absolution",
        "file": "attendez-que-je-me-suis-jamais-quoi.mp3",
        "title": "Attendez, que je me suis jamais quoi ? J'ai pas compris"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "ah-une-vache-pres-cest-pas-une-science-exacte.mp3",
        "title": "À une vache près hein, c'est pas une science exacte"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "nan-cest-nimporte-quoi.mp3",
        "title": "Nan c'est n'importe quoi"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "de-toute-facon-les-reunions-cest-2-fois-par-mois.mp3",
        "title": "De toutes façons les réunions de la table ronde, c’est deux fois par mois ! Donc si le mec il dit : après-demain, à partir de dans deux jours, suivant s’il le dit à la fin du mois ça reporte."
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "bah-ca-depend-a-partir-de-quand.mp3",
        "title": "Bah ça dépend à partir de quand. Après-demain à partir d'aujourd'hui ?"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "je-vous-ai-toujours-dit-ce-que-vous-faites-avec-les-chiffres.mp3",
        "title": "Je vous ai toujours dit : ce que vous faites avec les chiffres, même moi j'arrive pas à l'faire"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "cest-pour-voir-si-vous-avez-un-don.mp3",
        "title": "C'est pour voir si vous avez un don ou si vous êtes définitivement un nullos"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "nan-mais-en-vrai-pas-sur-la-carte.mp3",
        "title": "Nan nan mais en vrai, pas sur la carte, je comprends rien aux cartes"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "qu-est-ce-que-je-suis-en-train-de-faire-avec-mon-doigt.mp3",
        "title": "Qu'est-ce que je suis en train de faire avec mon doigt là ?"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 18 - Sept Cent Quarante-Quatre",
        "file": "il-est-fort-le-salaud.mp3",
        "title": "Il est fort le salaud"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 16 - Les Tuteurs",
        "file": "peut-etre-meme-que-je-mette-une-armure.mp3",
        "title": "Peut-être même qu'il faut que je mette une armure, ils sont capables de pas me reconnaître et d'essayer de me buter !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 16 - Les Tuteurs",
        "file": "des-betes-sauvages-que-je-vais-recuperer.mp3",
        "title": "Des bêtes sauvages que je vais récupérer, des machines à tuer"
    },
    {
        "character": "Yvain",
        "episode": "Livre II, 16 - Les Tuteurs",
        "file": "et-moi-je-me-suis-fait-derober-de-lalimentation-tout-le-long-du-voyage.mp3",
        "title": "Et moi je me suis fait dérober de l'alimentation tout le long du voyage une véritable dérobade !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 15 - Le Monde d'Arthur",
        "file": "pfiou-pfiou-pfiou.mp3",
        "title": "Pfiou Pfiou Pfiou"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 15 - Le Monde d'Arthur",
        "file": "boule-de-feu-boule-de-feu.mp3",
        "title": "Boule de feu ! Boule de feu !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "seigneur-bohort-je-commence-a-en-avoir-plein-le-dos.mp3",
        "title": "Seigneur Bohort, je commence à en avoir plein le dos de votre comportement de péteux ! Vous allez me faire le plaisir de me faire une bonne insulte et de vous foutre en rogne une bonne fois pour toutes !"
    },
    {
        "character": "Bohort",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "cest-un-scandale.mp3",
        "title": "C'est un scandale !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "mais-allez-y-magnez-vous-le-fion-espece-de-grosse-dinde.mp3",
        "title": "Mais allez-y bon sang, magnez-vous le fion espèce de grosse dinde !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "mais-allez-y-cest-pour-vous-stimuler-bon-dieu.mp3",
        "title": "Mais allez-y c'est pour vous stimuler, bon Dieu !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "vous-allez-me-montrer-ce-que-vous-avez-un-peu-dans-le-froc.mp3",
        "title": "Vous allez me montrer un peu ce que vous avez dans l'froc, ma mignonne !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre II, 14 - Les Classes de Bohort",
        "file": "allez-en-garde-espece-de-petite-couille-molle.mp3",
        "title": "Allez en garde espèce de petite couille molle !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 13 - L'Enlèvement de Guenièvre",
        "file": "quest-ce-que-vous-voulez-que-ca-me-foute.mp3",
        "title": "Qu'est-ce que vous voulez que ça me foute ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 13 - L'Enlèvement de Guenièvre",
        "file": "ah-putain-ouais-en-fait-vous-mavez-fait-lever-pour-rien.mp3",
        "title": "Ah putain ouais en fait vous m'avez fait lever pour rien"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 12 - La Délégation Maure",
        "file": "euh-si-il-lache-une-caisse-ca-le-fait-ou-pas.mp3",
        "title": "Euh... si il lâche une caisse ça l'fait ou pas ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 12 - La Délégation Maure",
        "file": "cest-personne-un-connard.mp3",
        "title": "C'est... personne, c'est... un connard. Asseyez-vous, je suis sûr qu'on va pouvoir trouver un accord"
    },
    {
        "character": "Le tavernier",
        "episode": "Livre II, 11 - Le Message Codé",
        "file": "ca-ca-doit-etre-du-code-parce-que-ca-veut-rien-dire.mp3",
        "title": "Ça ça doit être du code parce que ça veut rien dire"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 11 - Le Message Codé",
        "file": "il-faut-affranchir-nos-compagnons.mp3",
        "title": "Il faut affranchir nos compagnons"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 10 - La Chambre",
        "file": "mochete-en-plus-quand-on-voit-le-morceau-quil-se-trimballe.mp3",
        "title": "Mocheté en plus quand on voit le morceau qu'il se trimballe"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 10 - La Chambre",
        "file": "ah-cest-regle-hein-je-confirme.mp3",
        "title": "Ah c'est réglé hein, je confirme ! En ce moment, il range ses slibards dans ma commode"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 09 - Le Terroriste",
        "file": "pas-moyen-de-lui-faire-fermer-sa-gueule.mp3",
        "title": "Pas moyen de lui faire fermer sa gueule"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 08 - Les Volontaires II",
        "file": "par-contre-il-est-hyper-con-je-sais-pas-pourquoi.mp3",
        "title": "Par contre il est hyper con, j'sais pas pourquoi"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 08 - Les Volontaires II",
        "file": "salut-sire-je-trouve-quil-fait-beau-mais-encore-frais-mais-beau.mp3",
        "title": "Salut sire ! Je trouve qu'il fait beau mais encore frais, mais beau"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "vous-allez-me-promettre-de-pas-y-foutre-les-pieds.mp3",
        "title": "Vous allez me promettre de pas y foutre les pieds !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "sans-deconner-faut-pas-y-aller-demain.mp3",
        "title": "Sans déconner faut pas y aller demain"
    },
    {
        "character": "Merlin",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "mais-evidemment-cest-sans-alcool.mp3",
        "title": "Mais évidemment c'est sans alcool !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "la-blague-est-pas-drole.mp3",
        "title": "La blague est pas drôle !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 07 - Le Rassemblement du Corbeau",
        "file": "oh-la-vache-mais-cest-nul.mp3",
        "title": "Oh la vache, mais c'est nul !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 06 - Le Reclassement",
        "file": "ah-ca-quand-on-connait-pas-il-faut-se-mefier-avec-les-champignons.mp3",
        "title": "Ah ça, quand on connait pas, il faut se méfier avec les champignons"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 06 - Le Reclassement",
        "file": "quest-ce-que-vous-racontez-cest-pas-ca.mp3",
        "title": "Qu'est-ce que vous racontez ? C'est pas ça ! Simplement parce qu'on vous a vu de dos. Alors on s'est dit : \"qu'est-ce que c'est ? Tiens, on dirait un viking\""
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 06 - Le Reclassement",
        "file": "si-on-peut-sen-farcir-un-cest-toujours-ca-de-pris-quoi.mp3",
        "title": "Si on peut s'en farcir un ni vu ni connu, c'est toujours ça d'pris quoi... Oh pis on dira qu'c'est pas nous, allez !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "biensur-ils-ont-que-ca-a-foutre-les-paysans.mp3",
        "title": "Biensûr ! Ils ont qu'ça à foutre les paysans ! Bousiller les champs de blés pour dessiner des cercles !"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "oh-bah-oui-vous-en-etes-une-belle-forme-durticaire.mp3",
        "title": "Oh bah oui vous en êtes une belle vous d'forme d'urticaire"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 05 - Silbury Hill",
        "file": "mais-cest-pas-complique-quand-vous-voyez-des-gadins.mp3",
        "title": "Mais c'est pas compliqué : quand vous voyez des gadins de 12 pieds de haut plantés en rond, figurez-vous qu'ils n'ont pas poussé dans la nuit"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "vous-vous-devriez-arreter-de-sourire.mp3",
        "title": "Vous vous devriez arrêter de sourire parce que je vous promets ça devient vraiment malsain"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "moi-pour-quon-me-reconnaisse-faut-juste-2-3-coups-de-pinceaux.mp3",
        "title": "Moi pour qu'on me reconnaisse faut juste 2-3 coups de pinceaux mais vous..."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "ah-bah-voila-cherchez-pas-cest-hyper-flippant.mp3",
        "title": "Ah bah voilà, nan mais cherchez pas. Nan mais j'vous assure c'est hyper flippant"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "cest-l-autre-con-avec-ses-pinceaux.mp3",
        "title": "C'est l'autre con là avec ses pinceaux"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "mais-qu-est-ce-que-vous-venez-me-gonfler-avec-votre-pere-blaise.mp3",
        "title": "Mais qu'est-ce que vous venez me gonfler avec votre père Blaise !"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "oui-peut-etre-oui-oui.mp3",
        "title": "Oui peut-être oui oui..."
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 04 - Le Portrait",
        "file": "vous-faites-pas-la-gueule-la.mp3",
        "title": "Vous faites pas la gueule là ?"
    },
    {
        "character": "Séli",
        "episode": "Livre II, 03 - Le Dialogue de Paix",
        "file": "cest-pas-du-burgonde-ca.mp3",
        "title": "C'est pas du Burgonde ça"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 03 - Le Dialogue de Paix",
        "file": "decarre-tes-troupes-de-chez-moi-ou-je-crame-ton-pays.mp3",
        "title": "Décarre tes troupes de chez moi ou je crame ton pays. C'est assez simple comme vocabulaire ça ?"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "arretez-cest-pour-deconner.mp3",
        "title": "Arrêtez, c'est pour déconner !"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "on-est-indestructible.mp3",
        "title": "On est indestructible"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "ouais-cest-grace-a-notre-arme-secrete.mp3",
        "title": "Ouais, c'est grâce à notre arme secrète !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "bah-on-a-pas-de-technique-mais-cest-comme-tout.mp3",
        "title": "Bah on a pas de technique mais c'est comme tout, faut avoir du... voyez"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "allez-y-vous.mp3",
        "title": "Allez-y vous sentez là, il faut oser se lancer sinon vous progresserez jamais"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "vous-en-mettez-pas-trop.mp3",
        "title": "Vous en mettez pas trop"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "donc-cette-fiole.mp3",
        "title": "Donc cette fiole, selon comme elle pue, on dit qu'elle est plutôt bonne et faut pas trop en mettre"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 02 - Les Alchimistes",
        "file": "qu-est-ce-qui-a-dautre-qui-pue-sinon.mp3",
        "title": "Qu'est-ce qu'il y a d'autre qui pue sinon ?"
    },
    {
        "character": "Arthur",
        "episode": "Livre II, 01 - Spangenhelm",
        "file": "nan-ca-va-pas-etre-possible-ca.mp3",
        "title": "Nan ça va pas être possible ça"
    },
    {
        "character": "Perceval",
        "episode": "Teaser Kaamelott Le Film volet 1",
        "file": "patience-plat-sans-sauce.mp3",
        "title": "La patience est un plat qui se mange sans sauce"
    },
    {
        "character": "Karadoc",
        "episode": "Livre II, 53 - L'Absent",
        "file": "et-oui-meme-t-es-bien-mouchee.mp3",
        "title": "Et oui mémé, t'es bien mouchée héhéhéhé"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "oh-mais-vous-etes-des-malades.mp3",
        "title": "Oh mais vous êtes des malades !"
    },
    {
        "character": "Perceval",
        "episode": "Livre III, 37 - Le Repos du guerrier II",
        "file": "j_en_ai_rien_a_foutre_je_dors_dans_la_tente_du_roi.mp3",
        "title": "J'en ai rien à foutre, je dors dans la tente du roi !"
    },
    {
        "character": "Père Blaise",
        "episode": "Livre II, 55 - La Quinte Juste",
        "file": "cest_de_la_merde_2.mp3",
        "title": "C'est de la merde !"
    },
    {
        "character": "Perceval",
        "episode": "Livre II, 79 - La Botte secrète II",
        "file": "C_est_pas_comme_si_on_passait_pour_des_glands_tous_les_jours.mp3",
        "title": "Ouais remarquez ça va, c'est pas comme si on passait pour des glands tous les jours"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 6 - Le Garde du Corps",
        "file": "allez-y-mollo-avec-la-joie.mp3",
        "title": "Allez-y mollo avec la joie"
    },
    {
        "character": "Elias de Kelliwic'h",
        "episode": "Livre I, 15 - Les Défis de Merlin",
        "file": "cest-pas-pour-rien-quon-mappelle-le-fourbe.mp3",
        "title": "C'est pas pour rien qu'on m'appelle le fourbe"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "il-parle-pas-il-bouge-pas-il-fait-la-gueule-tout-le-temps.mp3",
        "title": "Il parle pas, il bouge pas, il fait la gueule tout le temps ! Dès qu'on lui fait une remarque, il lève les yeux au ciel ! Tiens, voilà !"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "jai-jamais-entendu-le-son-de-sa-voix.mp3",
        "title": "Première nouvelle ! J'ai jamais entendu le son de sa voix ! Hum... Si, là, voilà..."
    },
    {
        "character": "Léodagan",
        "episode": "Livre I, 39 - Le Cas Yvain",
        "file": "quand-il-a-rien-a-dire-il-dit-rien.mp3",
        "title": "Quand il a rien à dire, il dit rien. Il a pas été élevé chez les porcs, excusez-nous, hein"
    },
    {
        "character": "Arthur",
        "episode": "Livre II 48 - La Vigilance d'Arthur",
        "file": "ils-commencent-a-doucement-me-faire-chier-ceux-la-aussi.mp3",
        "title": "Commencent doucement à m'faire chier ceux là aussi"
    },
    {
        "character": "Arthur",
        "episode": "Livre I 97 - Agnus Dei",
        "file": "les-gars-me-regardent-avec-des-billes-comme-ca-et-ils-decrochent.mp3",
        "title": "Les gars me regardent avec des billes comme ça et puis ils décrochent hein... Ah rideau"
    },
    {
        "character": "Arthur",
        "episode": "Livre I 97 - Agnus Dei",
        "file": "je-suis-desole-jai-pas-eu-le-temps-de-potasser-les-formules.mp3",
        "title": "Donc heu Amen, 'fin Deu gracia j'sais plus quoi... J'suis désolé, j'ai pas eu le temps de potasser les formules"
    },
    {
        "character": "Arthur",
        "episode": "Livre I, 08 - Codes et Stratégies",
        "file": "jsuis_chef_de_guerre.mp3",
        "title": "J'suis chef de guerre moi, j'suis pas là pour secouder des drapeaux jouer de la trompette"
    },
    {
        "character": "Kadoc",
        "episode": "Livre III 82 - Witness",
        "file": "des_fois_on_a_pas_le_choix_faut_sacrifier_les_jeunes.mp3",
        "title": "Des fois on n'a pas le choix faut sacrifier les jeunes"
    },
    {
        "character": "Kadoc",
        "episode": "Livre III 82 - Witness",
        "file": "cest_le_grand_qui_a_dit.mp3",
        "title": "C'est le grand qui a dit"
    },
    {
        "character": "Léodagan",
        "episode": "Livre II 46 - Le cadeau",
        "file": "ah_ah_ah_les_pegus.mp3",
        "title": "Ah ah ah les pégus !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre V, 29 - Le Substitut",
        "file": "voila_zut.mp3",
        "title": "Voilà... zut !"
    },
    {
        "character": "Le Maître d'armes",
        "episode": "Livre V, 29 - Le Substitut",
        "file": "deja_que_ca_me_gonfle_de_porter_des_messages.mp3",
        "title": "Déjà que ça me gonfle de porter des messages, faisons en sorte que ça dure pas vingt ans !"
    }

]